// bn — checkin/quickCheck/stepTracker blocks translated.
export const bn = {
  "common": {
    "loading": "লোড হচ্ছে...",
    "save": "সংরক্ষণ করুন",
    "cancel": "বাতিল করুন",
    "delete": "মুছে ফেলুন",
    "edit": "সম্পাদনা",
    "close": "বন্ধ করুন",
    "confirm": "নিশ্চিত করুন",
    "back": "ফিরে যান",
    "next": "পরবর্তী",
    "submit": "জমা দিন",
    "search": "অনুসন্ধান",
    "select": "নির্বাচন করুন",
    "or": "অথবা",
    "and": "এবং",
    "note": "নোট",
    "viewAll": "সব দেখুন",
    "learnMore": "আরও জানুন",
    "getStarted": "শুরু করুন",
    "continue": "চালিয়ে যান",
    "saving": "সংরক্ষণ হচ্ছে…"
  },
  "nav": {
    "dashboard": "হোম",
    "nutrition": "পুষ্টি",
    "family": "পরিবার",
    "care": "পরিষেবা",
    "careShort": "পরিষেবা",
    "checkIn": "চেক-ইন",
    "insights": "পর্যবেক্ষণ",
    "trends": "ট্রেন্ড",
    "habits": "অভ্যাস",
    "medications": "ওষুধ",
    "expertSupport": "বিশেষজ্ঞ সহায়তা",
    "profile": "প্রোফাইল",
    "healthHub": "হেলথ হাব",
    "support": "সহায়তা",
    "wellness": "সুস্বাস্থ্য",
    "education": "শিক্ষা",
    "community": "কমিউনিটি",
    "preventiveHealth": "প্রতিরোধমূলক স্বাস্থ্য",
    "womensHealth": "নারীর স্বাস্থ্য",
    "reminders": "স্বাস্থ্য রিমাইন্ডার",
    "meals": "খাবার",
    "orders": "অর্ডার",
    "subscription": "সাবস্ক্রিপশন",
    "logout": "লগ আউট"
  },

  "navShort": {
    "dashboard": "হোম",
    "nutrition": "পুষ্টি",
    "family": "পরিবার",
    "care": "সেবা",
    "support": "সাহায্য",
    "profile": "প্রোফাইল"
  },
  "auth": {
    "login": "সাইন ইন",
    "register": "অ্যাকাউন্ট তৈরি করুন",
    "logout": "সাইন আউট",
    "email": "ইমেল",
    "password": "পাসওয়ার্ড",
    "name": "পুরো নাম",
    "forgotPassword": "পাসওয়ার্ড ভুলে গেছেন?",
    "noAccount": "অ্যাকাউন্ট নেই?",
    "haveAccount": "ইতিমধ্যেই অ্যাকাউন্ট আছে?",
    "signInHere": "এখানে সাইন ইন করুন",
    "signUpHere": "এখানে সাইন আপ করুন",
    "welcomeBack": "স্বাগতম!",
    "getStarted": "চলুন শুরু করি",
    "biometricLogin": "বায়োমেট্রিক দিয়ে সাইন ইন",
    "biometricHelper": "ফিঙ্গারপ্রিন্ট, ফেস আইডি বা উইন্ডোজ হ্যালো ব্যবহার করুন",
    "vendorLogin": "ভেন্ডর লগইন",
    "createOne": "একটি তৈরি করুন",
    "tagline": "আপনার স্বাস্থ্যের প্রতি সচেতন থাকুন — প্রতিদিন একটি সহজ পদক্ষেপের মাধ্যমে।",
    "takes30s": "৩০ সেকেন্ডের কম সময় লাগে",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "আপনার পাসওয়ার্ড লিখুন",
    "checking": "যাচাই করা হচ্ছে…",
    "continue": "চালিয়ে যান",
    "secureMessage": "নিরাপদ এবং ব্যক্তিগত — আপনার তথ্য সুরক্ষিত থাকে",
    "biometricSoon": "বায়োমেট্রিক লগইন — শীঘ্রই আসছে",
    "sessionExpired": "আপনার সেশনের সময় শেষ হয়েছে। যেখান থেকে শেষ করেছিলেন সেখান থেকে শুরু করতে আবার সাইন ইন করুন।",
    "showPassword": "পাসওয়ার্ড দেখুন",
    "hidePassword": "পাসওয়ার্ড লুকান",
    "vendor": {
      "title": "ভেন্ডর পার্টনার লগইন",
      "subtitle": "আপনার HealthLoop ভেন্ডর ড্যাশবোর্ড অ্যাক্সেস করুন",
      "businessEmail": "ব্যবসায়িক ইমেল",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "লগইন হচ্ছে...",
      "signIn": "লগইন করুন",
      "notVendorYet": "এখনও ভেন্ডর পার্টনার হননি?",
      "registerBusiness": "আপনার ব্যবসা নিবন্ধন করুন",
      "areYouUser": "আপনি কি একজন ব্যবহারকারী?",
      "userLogin": "ইউজার লগইন",
      "welcomeBackToast": "আপনাকে আবারো স্বাগতম!",
      "genericError": "লগইন ব্যর্থ হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।"
    },
    "admin": {
      "backToUserLogin": "ইউজার সাইন-ইন",
      "title": "অ্যাডমিন সাইন-ইন",
      "restrictedBadge": "সীমাবদ্ধ",
      "tagline": "HealthLoop অপারেটর কনসোল — অ্যাডমিন শংসাপত্র প্রয়োজন।",
      "emailLabel": "অ্যাডমিন ইমেল",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "পাসওয়ার্ড",
      "passwordPlaceholder": "আপনার অ্যাডমিন পাসওয়ার্ড দিন",
      "signingIn": "সাইন-ইন হচ্ছে…",
      "submit": "অ্যাডমিন কনসোলে সাইন-ইন করুন",
      "secureNote": "সুরক্ষিত সংযোগ · সেশন এনক্রিপ্টেড",
      "restrictedTitle": "এই এলাকাটি শুধুমাত্র অ্যাডমিনদের জন্য সীমাবদ্ধ।",
      "restrictedBody": "আপনার অ্যাকাউন্ট সাইন-ইন করা আছে, কিন্তু এতে অ্যাডমিন অ্যাক্সেস নেই। অন্য কোনো অ্যাকাউন্টে চেষ্টা করার জন্য সাইন-আউট করুন, অথবা মূল অ্যাপে ফিরে যান।",
      "signOut": "সাইন-আউট",
      "backToApp": "অ্যাপে ফিরে যান"
    }
  },
  "quickCheck": {
    "header": {
      "title": "আজ আপনার কেমন বোধ হচ্ছে?",
      "subtitle": "দ্রুত চেক-ইন — এটি ৬০ সেকেন্ডেরও কম সময় নেবে"
    },
    "section1": {
      "title": "আজ আপনি কী খেয়াল করছেন?",
      "hint": "(প্রযোজ্য সব কটি বেছে নিন)"
    },
    "environment": {
      "title": "আপনার চারপাশ",
      "hint": "আপনার চারপাশের পরিবেশ বুঝতে আমাদের সাহায্য করুন"
    },
    "basicChecks": {
      "title": "দ্রুত সাধারণ চেক",
      "hint": "ঐচ্ছিক তবে সহায়ক"
    },
    "validation": {
      "pickOne": "অনুগ্রহ করে অন্তত একটি প্রশ্নের উত্তর দিন"
    },
    "submit": {
      "cta": "আমার হেলথ ইনসাইট দেখুন",
      "saving": "সেভ হচ্ছে...",
      "analyzing": "আপনার স্বাস্থ্যের ধরন বিশ্লেষণ করা হচ্ছে...",
      "savedToast": "✅ চেক-ইন সেভ করা হয়েছে! আপনার স্বাস্থ্যের ধরন বিশ্লেষণ করা হচ্ছে..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "স্টেপ ট্র্যাকার",
      "subtitle": "সঠিক এবং নির্ভরযোগ্য অ্যাক্টিভিটি ট্র্যাকিং",
      "backToDashboard": "ড্যাশবোর্ডে ফিরে যান"
    },
    "today": {
      "title": "আজকের পদক্ষেপ",
      "goalProgress": "{{current}} / {{goal}} পদক্ষেপ",
      "goalReached": "লক্ষ্য পূরণ হয়েছে — দারুণ কাজ!",
      "keepGoing": "এগিয়ে চলুন — আপনি সঠিক পথেই আছেন।"
    },
    "streak": {
      "label": "বর্তমান স্ট্রিক",
      "days": "{{count}} দিন",
      "daysPlural": "{{count}} দিন"
    },
    "badges": {
      "title": "ব্যাজ",
      "empty": "অভ্যাস গড়ে তোলার সাথে সাথে আপনি ব্যাজ অর্জন করবেন।"
    },
    "reminders": {
      "title": "হাঁটাচলার তাগিদ",
      "hint": "দীর্ঘক্ষণ বসে থাকলে অল্প হাঁটাচলার জন্য মৃদু রিমাইন্ডার।",
      "enabled": "চালু আছে",
      "disabled": "বন্ধ আছে"
    },
    "insights": {
      "weeklyAverage": "সাপ্তাহিক গড়",
      "weeklyGoal": "সাপ্তাহিক লক্ষ্য"
    },
    "actions": {
      "connect": "স্টেপ সোর্স যুক্ত করুন",
      "manualLog": "ম্যানুয়ালি পদক্ষেপ যোগ করুন",
      "changeGoal": "প্রতিদিনের লক্ষ্য পরিবর্তন করুন"
    }
  },
  "checkin": {
    "header": {
      "title": "প্রতিদিনের হেলথ চেক-ইন",
      "subtitle": "৬০ সেকেন্ডেরও কম সময় লাগবে",
      "restDayLink": "আজ শরীরটা ঠিক ভালো লাগছে না"
    },
    "snapshot": {
      "title": "আপনার ড্যাশবোর্ড আপডেট করা হয়েছে",
      "healthScore": "হেলথ স্কোর",
      "todayTasks": "আজকের কাজ",
      "dayStreak": "দিনের স্ট্রিক"
    },
    "resume": {
      "banner": "যেখানে ছেড়েছিলেন সেখান থেকেই শুরু করুন",
      "startFresh": "নতুন করে শুরু করুন",
      "dismiss": "বাতিল করুন"
    },
    "progress": {
      "allSet": "সব তৈরি",
      "step": "{{total}}-এর মধ্যে {{current}} নম্বর ধাপ",
      "ariaLabel": "প্রতিদিনের চেক-ইন প্রগতি: {{total}}-এর মধ্যে {{done}}টি বিভাগ সম্পন্ন হয়েছে"
    },
    "insights": {
      "title": "আপনার স্বাস্থ্যের অবস্থা",
      "subtitle": "আজকের জন্য আপনার ব্যক্তিগত তথ্য",
      "insightForYou": "আপনার জন্য পরামর্শ",
      "simpleActions": "সহজ কিছু পদক্ষেপ যা আপনি নিতে পারেন",
      "whenToSeekHelp": "কখন সহায়তার প্রয়োজন",
      "nhsAdvice": "চিন্তিত হলে, NHS 111 বা আপনার ডাক্তারের সাথে যোগাযোগ করুন",
      "backToDashboard": "ড্যাশবোর্ডে ফিরে যান",
      "newCheckIn": "নতুন চেক-ইন",
      "disclaimer": "HealthLoop শুধুমাত্র গাইডেন্স প্রদান করে, কোনো মেডিকেল ডায়াগনোসিস নয়।"
    },
    "restDay": {
      "title": "বিশ্রামও দৈনন্দিন ছন্দের অংশ।",
      "body": "আপনি যখন প্রস্তুত হবেন, আমরা আগামীকাল এখানেই থাকব।",
      "streakNote": "আপনার স্ট্রিক কমেনি — এটিও শুধু একটু বিশ্রাম নিচ্ছে।",
      "backToDashboard": "ড্যাশবোর্ডে ফিরে যান",
      "changedMind": "আসলে, আমি চেক-ইন করতে চাই।"
    },
    "feelings": {
      "title": "আজ আপনার কেমন বোধ হচ্ছে?",
      "hint": "প্রযোজ্য সব কটি বেছে নিন",
      "tired": "ক্লান্তি অনুভব করছি",
      "headache": "মাথাব্যথা",
      "stressed": "মানসিক চাপ বা অতিরিক্ত চাপ বোধ করছি",
      "pain": "শরীরে ব্যথা বা বেদনা",
      "okay": "আজ ভালো বোধ করছি"
    },
    "basics": {
      "title": "আপনার সাধারণ তথ্যাবলি",
      "sleepQ": "গত রাতে কি আপনার ভালো ঘুম হয়েছে?",
      "waterQ": "আজ কি আপনি পর্যাপ্ত জল খেয়েছেন?",
      "foodQ": "আজ কি আপনি ঠিকমতো খাবার খেয়েছেন?",
      "activityQ": "আজ আপনি কতটা সক্রিয় ছিলেন?",
      "yes": "হ্যাঁ",
      "notReally": "খুব একটা নয়",
      "notYet": "এখনও নয়",
      "notActive": "সক্রিয় ছিলাম না",
      "lightActivity": "হালকা সক্রিয়তা",
      "active": "সক্রিয়"
    },
    "mind": {
      "title": "মন ও শক্তি",
      "stressQ": "আজ আপনার মানসিক চাপের মাত্রা কেমন?",
      "moodQ": "আজ আপনার মেজাজ কেমন?",
      "energyQ": "আজ আপনার শক্তির মাত্রা কেমন?",
      "low": "কম",
      "moderate": "মাঝারি",
      "high": "বেশি",
      "neutral": "স্বাভাবিক",
      "good": "ভালো",
      "okay": "মোটামুটি"
    },
    "day": {
      "title": "আপনার দিনটি কেমন কাটল",
      "routineQ": "আপনি কি আজ আপনার স্বাভাবিক রুটিন মেনে চলেছেন?",
      "yes": "হ্যাঁ",
      "no": "না"
    },
    "environment": {
      "title": "আপনার চারপাশ",
      "describeQ": "আপনার চারপাশের পরিবেশ কেমন ছিল?",
      "comfortable": "😊 আরামদায়ক",
      "slightlyUncomfortable": "😐 সামান্য অস্বস্তিকর",
      "challenging": "😓 প্রতিকূল",
      "affectedQ": "আপনার পরিবেশ কি আপনার অনুভূতির ওপর প্রভাব ফেলেছে?",
      "yes": "হ্যাঁ",
      "no": "না",
      "exposureLabel": "পরিবেশের প্রভাব (প্রযোজ্য সব কটি বেছে নিন)",
      "heat": "🌡️ গরম",
      "cold": "❄️ ঠান্ডা",
      "noise": "🔊 কোলাহল",
      "dustSmoke": "💨 ধুলো বা ধোঁয়া",
      "crowded": "👥 ভিড়",
      "none": "✅ কোনোটিই নয়"
    },
    "submit": {
      "analyzing": "আপনার স্বাস্থ্যের ধরন বিশ্লেষণ করা হচ্ছে...",
      "cta": "আমার স্বাস্থ্যের ইনসাইট দেখুন"
    },
    "toast": {
      "savedFull": "চেক-ইন সেভ করা হয়েছে! আপনার ড্যাশবোর্ড আপডেট করা হয়েছে।",
      "savedShort": "চেক-ইন সেভ করা হয়েছে।"
    }
  },
  "onboarding": {
    "welcome": "স্বাগতম",
    "completeSetup": "সেটআপ সম্পন্ন করুন",
    "stepProgress": "ধাপ {{step}}/{{total}}",
    "percentComplete": "{{percent}}% সম্পন্ন",
    "welcomeToast": "HealthLoop-এ স্বাগতম! আপনার প্রোফাইল সেট আপ করা হয়েছে।",
    "errorAgeRange": "আপনার বয়সের সীমা নির্বাচন করুন",
    "errorCountry": "আপনার দেশ নির্বাচন করুন",
    "errorGoal": "আপনার প্রধান স্বাস্থ্য লক্ষ্য নির্বাচন করুন",
    "errorCuisine": "কমপক্ষে একটি খাবারের পছন্দ নির্বাচন করুন",
    "errorGeneric": "অনবোর্ডিং সম্পন্ন করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
    "step1Title": "HealthLoop-এ স্বাগতম! 👋",
    "step1Subtitle": "চলুন আপনার স্বাস্থ্যের যাত্রা শুরু করি",
    "ageRangeLabel": "আপনার বয়সের সীমা কত?",
    "genderLabel": "লিঙ্গ (ঐচ্ছিক)",
    "gender_male": "পুরুষ",
    "gender_female": "মহিলা",
    "gender_non-binary": "নন-বাইনারি",
    "gender_prefer_not_to_say": "বলতে অনিচ্ছুক",
    "step2Title": "আপনি কোথায় থাকেন? 🌍",
    "step2Subtitle": "এটি আমাদের পছন্দসই খাবার সুপারিশ করতে সাহায্য করে",
    "countryLabel": "আপনার দেশ নির্বাচন করুন",
    "country_uk": "যুক্তরাজ্য",
    "country_nigeria": "নাইজেরিয়া",
    "country_ghana": "ঘানা",
    "country_kenya": "কেনিয়া",
    "country_south_africa": "দক্ষিণ আফ্রিকা",
    "country_usa": "মার্কিন যুক্তরাষ্ট্র",
    "country_canada": "কানাডা",
    "country_india": "ভারত",
    "country_jamaica": "জ্যামাইকা",
    "country_other": "অন্যান্য",
    "step3Title": "আপনার প্রধান লক্ষ্য কী? 🎯",
    "step3Subtitle": "আপনার প্রাথমিক স্বাস্থ্য লক্ষ্য বেছে নিন",
    "additionalGoals": "অন্য কোন লক্ষ্য আছে? (ঐচ্ছিক)",
    "goal_weight_loss": "ওজন কমানো",
    "goalDesc_weight_loss": "স্বাস্থ্যকরভাবে ওজন কমান",
    "goal_weight_maintenance": "ওজন নিয়ন্ত্রণ",
    "goalDesc_weight_maintenance": "বর্তমান ওজন বজায় রাখা",
    "goal_muscle_gain": "পেশী তৈরি",
    "goalDesc_muscle_gain": "শক্তি ও পেশী বৃদ্ধি",
    "goal_general_wellness": "সাধারণ সুস্বাস্থ্য",
    "goalDesc_general_wellness": "সামগ্রিক স্বাস্থ্যের উন্নতি",
    "goal_better_sleep": "ভালো ঘুম",
    "goalDesc_better_sleep": "ঘুমের মান উন্নত করুন",
    "goal_reduce_stress": "মানসিক চাপ কমানো",
    "goalDesc_reduce_stress": "মানসিক চাপ আরও ভালো ভাবে নিয়ন্ত্রণ করা",
    "goal_increase_energy": "শক্তি বৃদ্ধি",
    "goalDesc_increase_energy": "আরও চনমনে বোধ করা",
    "step4Title": "খাবারের পছন্দ 🍽️",
    "step4Subtitle": "আপনার পছন্দের খাবার এবং ডায়েটরি বিধিনিষেধগুলো বেছে নিন",
    "cuisineLabel": "পছন্দের খাবার (Cuisines)",
    "cuisineHint": "কমপক্ষে একটি বেছে নিন (একাধিক বাছতে পারেন)",
    "dietaryLabel": "ডায়েটরি বিধিনিষেধ (ঐচ্ছিক)",
    "diet_vegetarian": "নিরামিষভোজী",
    "diet_vegan": "ভেগান",
    "diet_halal": "হালাল",
    "diet_kosher": "কোশার",
    "diet_gluten_free": "গ্লুটেন-মুক্ত",
    "diet_dairy_free": "দুগ্ধজাত-মুক্ত",
    "diet_pescatarian": "পেসকাটেরিয়ান",
    "step5Title": "শারীরিক অবস্থা 🏥",
    "step5Subtitle": "ঐচ্ছিক — এটি আমাদের আরও ভালো পরামর্শ দিতে সাহায্য করে",
    "conditionsLabel": "আপনার কি এর মধ্যে কোনো সমস্যা আছে?",
    "conditionsHint": "এই তথ্যগুলো গোপন রাখা হবে এবং আপনার অভিজ্ঞতাকে উন্নত করতে সাহায্য করবে",
    "condition_diabetes": "ডায়াবেটিস",
    "condition_hypertension": "উচ্চ রক্তচাপ",
    "condition_heart_disease": "হৃদরোগ",
    "condition_thyroid": "থাইরয়েড সমস্যা",
    "condition_celiac": "সেলিয়াক ডিজিজ",
    "condition_ibs": "আইবিএস (IBS)",
    "condition_none": "কোনটিই নয়",
    "privacyTitle": "আপনার তথ্য সুরক্ষিত",
    "privacyBody": "আপনার ব্যক্তিগত তথ্য এনক্রিপ্ট করা এবং নিরাপদে সংরক্ষিত। আমরা এই তথ্যগুলো শুধুমাত্র আপনার খাবারের পরামর্শ, স্বাস্থ্য টিপস এবং নোটিফিকেশন ব্যক্তিগতকৃত করতে ব্যবহার করি। আপনার সম্মতি ছাড়া আপনার তথ্য কখনোই তৃতীয় পক্ষের সাথে শেয়ার করা হবে না।",
    "trackMedication": "আমি আমার ওষুধ ট্র্যাক করতে চাই",
    "specialistInterest": "আমি বিশেষজ্ঞ পরামর্শে আগ্রহী",
    "welcomeTitle": "HealthLoop-এ আপনাকে স্বাগতম! 👋",
    "welcomeSubtitle": "কয়েকটি সহজ ধাপের মাধ্যমে আপনার জন্য উপযুক্ত এআই-চালিত প্রিভেন্টিভ হেলথ এবং লাইফস্টাইল বুদ্ধিমত্তা তৈরি করে নিন",
    "stepLabel": "{{total}}-এর মধ্যে {{current}} নম্বর ধাপ",
    "skipForNow": "আপাতত বাদ দিন",
    "skipToast": "আপনি আপনার প্রোফাইল থেকে যেকোনো সময় অনবোর্ডিং সম্পন্ন করতে পারেন",
    "back": "পেছনে",
    "next": "পরবর্তী",
    "completing": "সম্পন্ন হচ্ছে...",
    "complete": "সেটআপ সম্পন্ন করুন",
    "successToast": "HealthLoop-এ স্বাগতম! আপনার প্রোফাইল এখন আপনার পছন্দ অনুযায়ী সাজানো হয়েছে 🎉",
    "failureToast": "অনবোর্ডিং সম্পন্ন করা যায়নি",
    "validation": {
      "basicInfo": "অনুগ্রহ করে সব মৌলিক তথ্য প্রদান করুন",
      "pickGoal": "অনুগ্রহ করে অন্তত একটি স্বাস্থ্যের লক্ষ্য নির্বাচন করুন",
      "pickPrimary": "অনুগ্রহ করে আপনার প্রধান লক্ষ্যটি নির্বাচন করুন",
      "pickRegion": "ব্যক্তিগত খাবারের পরামর্শের জন্য আপনার সাংস্কৃতিক অঞ্চল নির্বাচন করুন",
      "pickFocus": "আপনার প্রধান ওয়েলনেস ফোকাস নির্বাচন করুন"
    },
    "step1": {
      "title": "আপনার স্বাস্থ্যের প্রোফাইল",
      "description": "আপনার জন্য ব্যক্তিগত এআই হেলথ ইন্টেলিজেন্স তৈরি করতে আমাদের সাহায্য করুন",
      "age": "বয়স *",
      "agePlaceholder": "যেমন: ৩০",
      "height": "উচ্চতা (সেমি) *",
      "heightPlaceholder": "যেমন: ১৭০",
      "weight": "ওজন (কেজি) *",
      "weightPlaceholder": "যেমন: ৭০"
    },
    "step2": {
      "title": "আপনার স্বাস্থ্যের লক্ষ্য",
      "description": "প্রযোজ্য সবগুলি নির্বাচন করুন, তারপর আপনার প্রধান লক্ষ্যটি বেছে নিন",
      "primaryLabel": "আপনার প্রধান লক্ষ্যটি নির্বাচন করুন *",
      "primaryBadge": "প্রধান"
    },
    "step3": {
      "title": "🌍 সংস্কৃতি ও খাদ্যের পছন্দ",
      "description": "আপনার খাবারের পরামর্শগুলো ব্যক্তিগতকৃত করতে আমাদের সাহায্য করুন",
      "regionLabel": "সাংস্কৃতিক অঞ্চল *",
      "regionHint": "ব্যক্তিগত খাবারের পরামর্শ পেতে আপনার সাংস্কৃতিক পটভূমি নির্বাচন করুন",
      "countryLabel": "দেশ (ঐচ্ছিক)",
      "countryPlaceholder": "যেমন: নাইজেরিয়া, কেনিয়া, জামাইকা",
      "countryHint": "আরও নিখুঁত পরামর্শ পাওয়ার জন্য",
      "foodPrefLabel": "খাদ্যের বৈচিত্র্যের পছন্দ"
    },
    "step4": {
      "title": "প্রধান ওয়েলনেস ফোকাস",
      "description": "আপনি কোন বিষয়ে সবচেয়ে বেশি গুরুত্ব দিতে চান তা বেছে নিন"
    },
    "step5": {
      "title": "আপনার পছন্দসমূহ",
      "description": "আপনার HealthLoop অভিজ্ঞতা কাস্টমাইজ করুন",
      "trackMeds": "ওষুধ ট্র্যাক করুন",
      "trackMedsHint": "আপনার দৈনন্দিন চেক-ইন-এ ওষুধের ট্র্যাকিং এবং রিমাইন্ডার চালু করুন",
      "specialist": "বিশেষজ্ঞ সহায়তায় আগ্রহী",
      "specialistHint": "ওয়েলনেস বিশেষজ্ঞ, পুষ্টিবিদ এবং মানসিক স্বাস্থ্য পেশাদারদের পরামর্শ নিন",
      "confidentialTitle": "গোপনীয় সহায়তা:",
      "confidentialBody": "আপনার সমস্ত তথ্য সুরক্ষিত এবং শুধুমাত্র ব্যক্তিগত প্রিভেন্টিভ হেলথ ইনসাইট প্রদানের জন্য ব্যবহৃত হয়।"
    },
    "step6": {
      "title": "খাবার ব্যক্তিগতকরণ",
      "description": "আপনার স্বাদ এবং খাদ্যাভ্যাস অনুযায়ী খাবারের পরামর্শ দিতে আমাদের সাহায্য করুন",
      "cuisinesLabel": "পছন্দের রন্ধনশৈলী (ঐচ্ছিক)",
      "cuisinesHint": "আপনার সবচেয়ে প্রিয় রন্ধনশৈলীগুলো নির্বাচন করুন",
      "dietaryLabel": "খাদ্যতালিকাগত বিধিনিষেধ (ঐচ্ছিক)",
      "dietaryHint": "আপনার জন্য প্রযোজ্য বিষয়গুলো নির্বাচন করুন",
      "allergiesLabel": "সাধারণ অ্যালার্জি (ঐচ্ছিক)",
      "allergiesHint": "যেকোনো খাবারে অ্যালার্জি থাকলে তা নির্বাচন করুন",
      "personalisedTitle": "ব্যক্তিগতকৃত খাবার:",
      "personalisedBody": "আমরা আপনার পছন্দ অনুযায়ী খাবারের পরামর্শ দেব। আপনি পরবর্তীতে সেটিংস থেকে এগুলো পরিবর্তন করতে পারেন।"
    },
    "healthGoals": {
      "better_sleep": "উন্নত ঘুম",
      "reduce_stress": "মানসিক চাপ কমানো",
      "increase_energy": "শক্তি বৃদ্ধি",
      "weight_management": "ওজন নিয়ন্ত্রণ",
      "improve_fitness": "ফিটনেস বৃদ্ধি",
      "better_nutrition": "উন্নত পুষ্টি",
      "mental_wellness": "মানসিক প্রশান্তি",
      "chronic_condition": "দীর্ঘস্থায়ী অবস্থা ব্যবস্থাপনা"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "মানসিক স্বাস্থ্য",
        "description": "মেজাজ, মানসিক চাপ এবং আবেগীয় সুস্থতার ওপর গুরুত্ব দিন"
      },
      "physical_fitness": {
        "label": "শারীরিক ফিটনেস",
        "description": "ব্যায়াম, শক্তি এবং সক্রিয়তার ওপর গুরুত্ব দিন"
      },
      "nutrition": {
        "label": "পুষ্টি",
        "description": "ডায়েট, খাবার এবং স্বাস্থ্যকর খাদ্যাভ্যাসের ওপর গুরুত্ব দিন"
      },
      "sleep": {
        "label": "ঘুমের মান",
        "description": "বিশ্রাম, ঘুমের ধরণ এবং রিকভারির ওপর গুরুত্ব দিন"
      },
      "stress_management": {
        "label": "মানসিক চাপ ব্যবস্থাপনা",
        "description": "শিথিলতা এবং মানসিক চাপ কমানোর ওপর গুরুত্ব দিন"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "পশ্চিম আফ্রিকান",
        "description": "নাইজেরিয়ান, ঘানাইয়ান, সেনেগালিজ খাবার"
      },
      "east_african": {
        "label": "পূর্ব আফ্রিকান",
        "description": "কেনিয়ান, ইথিওপিয়ান, তানজানিয়ান খাবার"
      },
      "north_african": {
        "label": "উত্তর আফ্রিকান",
        "description": "মরক্কান, মিশরীয় খাবার"
      },
      "southern_african": {
        "label": "দক্ষিণ আফ্রিকান",
        "description": "দক্ষিণ আফ্রিকান খাবার"
      },
      "caribbean": {
        "label": "ক্যারিবিয়ান",
        "description": "জামাইকান, ত্রিনিদাদিয়ান, বার্বাডিয়ান খাবার"
      },
      "middle_eastern": {
        "label": "মধ্যপ্রাচ্য",
        "description": "লেবানিজ, ফিলিস্তিনি, সিরিয়ান খাবার"
      },
      "south_asian": {
        "label": "দক্ষিণ এশীয়",
        "description": "ভারতীয়, পাকিস্তানি, বাংলাদেশি খাবার"
      },
      "east_asian": {
        "label": "পূর্ব এশীয়",
        "description": "চীনা, জাপানি, কোরিয়ান খাবার"
      },
      "southeast_asian": {
        "label": "দক্ষিণ-পূর্ব এশীয়",
        "description": "থাই, ভিয়েতনামী, ইন্দোনেশিয়ান খাবার"
      },
      "western": {
        "label": "পাশ্চাত্য",
        "description": "আমেরিকান, ইউরোপীয় খাবার"
      },
      "latin_american": {
        "label": "ল্যাটিন আমেরিকান",
        "description": "মেক্সিকান, ব্রাজিলিয়ান, আর্জেন্টাইন খাবার"
      },
      "mediterranean": {
        "label": "ভূমধ্যসাগরীয়",
        "description": "গ্রিক, ইতালীয়, স্প্যানিশ খাবার"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "ঐতিহ্যবাহী",
        "description": "মূলত আপনার সাংস্কৃতিক অঞ্চলের খাবার"
      },
      "mixed": {
        "label": "মিশ্র",
        "description": "স্থানীয় এবং আন্তর্জাতিক খাবারের ভারসাম্য"
      },
      "international": {
        "label": "আন্তর্জাতিক",
        "description": "বিভিন্ন বৈশ্বিক রন্ধনশৈলী"
      }
    },
    "cuisines": {
      "west_african": "পশ্চিম আফ্রিকান",
      "caribbean": "ক্যারিবিয়ান",
      "mediterranean": "ভূমধ্যসাগরীয়",
      "asian": "এশীয়",
      "western": "পাশ্চাত্য",
      "indian": "ভারতীয়",
      "middle_eastern": "মধ্যপ্রাচ্য",
      "general": "সব ধরণের খাবার"
    },
    "dietary": {
      "vegetarian": "নিরামিষভোজী",
      "vegan": "ভেগান",
      "pescatarian": "পেসকাটেরিয়ান",
      "gluten_free": "গ্লুটেন-মুক্ত",
      "dairy_free": "দুগ্ধজাত-মুক্ত",
      "low_carb": "লো-কার্ব"
    },
    "allergies": {
      "nuts": "বাদাম",
      "shellfish": "শেলফিশ",
      "dairy": "দুগ্ধজাত খাবার",
      "eggs": "ডিম",
      "soy": "সয়া",
      "gluten": "গ্লুটেন"
    },
    "cuisine_nigerian": "নাইজেরীয়",
    "cuisine_ghanaian": "ঘানায়ীয়",
    "cuisine_senegalese": "সেনেগালিজ",
    "cuisine_kenyan": "কেনীয়",
    "cuisine_ethiopian": "ইথিওপীয়",
    "cuisine_moroccan": "মরক্কীয়",
    "cuisine_south_african": "দক্ষিণ আফ্রিকান",
    "cuisine_jamaican": "জ্যামাইকান",
    "cuisine_trinidadian": "ত্রিনিদাদিয়ান",
    "cuisine_lebanese": "লেবানিজ",
    "cuisine_turkish": "তুর্কি",
    "cuisine_greek": "গ্রিক",
    "cuisine_italian": "ইতালীয়",
    "cuisine_french": "ফরাসি",
    "cuisine_british": "ব্রিটিশ",
    "cuisine_indian_south": "দক্ষিণ ভারতীয়",
    "cuisine_indian_north": "উত্তর ভারতীয়",
    "cuisine_pakistani": "পাকিস্তানি",
    "cuisine_japanese": "জাপানি",
    "cuisine_chinese": "চীনা",
    "cuisine_korean": "কোরীয়",
    "cuisine_vietnamese": "ভিয়েতনামী",
    "cuisine_thai": "থাই",
    "cuisine_filipino": "ফিলিপিনো",
    "cuisine_american": "আমেরিকান",
    "cuisine_mexican": "মেক্সিকান",
    "cuisine_brazilian": "ব্রাজিলীয়",
    "cuisine_peruvian": "পেরুভীয়"
  },
  "dashboard": {
    "welcome": "আবার স্বাগতম",
    "greeting": "হ্যালো",
    "goodMorning": "শুভ সকাল",
    "goodAfternoon": "শুভ অপরাহ্ন",
    "goodEvening": "শুভ সন্ধ্যা",
    "tagline": "ছোট ছোট স্বাস্থ্যকর পদক্ষেপই দীর্ঘস্থায়ী পরিবর্তন আনে",
    "microcopy": "আপনার সুস্বাস্থ্যের যাত্রা গুরুত্বপূর্ণ।",
    "welcomeSubtitleMorning1": "দিনের এক শান্ত শুরু।",
    "welcomeSubtitleMorning2": "আজ সকালে আপনার আসার জন্য ধন্যবাদ।",
    "welcomeSubtitleMorning3": "ছোট ছোট মুহূর্ত অনেক বড় হয়।",
    "welcomeSubtitleAfternoon1": "আশা করি আপনার দিনটি ভালো কাটছে।",
    "welcomeSubtitleAfternoon2": "HealthLoop-এ আবার স্বাগতম।",
    "welcomeSubtitleAfternoon3": "একটু দম নিন — আপনি ভালো করছেন।",
    "welcomeSubtitleEvening1": "আপনার সাথে দিনটি শেষ করছি।",
    "welcomeSubtitleEvening2": "দিনের এক সুন্দর সমাপ্তি।",
    "welcomeSubtitleEvening3": "আজ সন্ধ্যায় আপনাকে স্বাগতম।",
    "title": "আপনার প্রতিরোধমূলক স্বাস্থ্য প্ল্যাটফর্ম",
    "subtitle": "সমস্যা বাড়ার আগেই ট্র্যাক করুন, শিখুন এবং ব্যবস্থা নিন",
    "summary": "আপনার স্বাস্থ্য তথ্যের সারাংশ",
    "summaryDesc": "প্রতিরোধ, শিক্ষা, অংশগ্রহণ এবং সুস্থতার রিয়েল-টাইম পর্যবেক্ষণ",
    "comprehensiveSupport": "প্রতিরোধ, শিক্ষা, অংশগ্রহণ এবং সুস্থতায় সামগ্রিক সহায়তা",
    "todayCheckIn": "আজকের চেক-ইন",
    "quickActions": "দ্রুত কাজ",
    "healthOverview": "স্বাস্থ্যের সংক্ষিপ্ত চিত্র",
    "recentActivity": "সাম্প্রতিক কার্যকলাপ",
    "viewAll": "সব দেখুন",
    "preventiveHealth": "প্রতিরোধমূলক স্বাস্থ্য",
    "preventiveHealthDesc": "দৈনিক ট্র্যাকিং, সুস্থতা পর্যবেক্ষণ এবং প্রতিরোধমূলক সতর্কবার্তা",
    "education": "শিক্ষা",
    "educationDesc": "প্রমাণ-ভিত্তিক তথ্য, স্বাস্থ্য নিবন্ধ এবং বিশেষজ্ঞ নির্দেশিকা",
    "engagement": "অংশগ্রহণ",
    "engagementDesc": "কমিউনিটি চ্যালেঞ্জ, অভ্যাস ট্র্যাকিং এবং সামাজিক সহায়তা",
    "wellness": "সুস্বাস্থ্য",
    "wellnessDesc": "স্মার্ট পুষ্টি, লাইফস্টাইল ব্যালেন্স এবং সামগ্রিক সুস্থতা",
    "todaysInsight": "আজকের পর্যবেক্ষণ",
    "wellnessScore": "সুস্থতার স্কোর",
    "healthStreak": "হেলথ স্ট্রিক",
    "days": "দিন",
    "logHealth": "স্বাস্থ্য তথ্য যোগ করুন",
    "getEducated": "জ্ঞান অর্জন করুন",
    "communityChallenge": "কমিউনিটি চ্যালেঞ্জ",
    "checkWellness": "সুস্থতা পরীক্ষা করুন",
    "verified": "ভেরিফাইড",
    "joinCommunity": "কমিউনিটিতে যোগ দিন",
    "personalizedPlan": "ব্যক্তিগতকৃত পরিকল্পনা",
    "score": "স্কোর",
    "checkIns": "চেক-ইন",
    "habits": "অভ্যাস",
    "preventive": "প্রতিরোধমূলক",
    "healthMetrics": "স্বাস্থ্যের মাপকাঠি",
    "trackMetrics": "মাপকাঠি ট্র্যাক করুন",
    "startTracking": "ট্র্যাকিং শুরু করুন",
    "logMetrics": "মেট্রিক্স যোগ করুন",
    "dailyInsight": "দৈনিক তথ্য",
    "learnAbout": "আজই প্রতিরোধমূলক স্বাস্থ্য সম্পর্কে জানুন",
    "articlesAvailable": "নিবন্ধ উপলব্ধ",
    "browseArticles": "নিবন্ধগুলো দেখুন",
    "currentStreak": "বর্তমান স্ট্রিক",
    "keepGoing": "এভাবেই চালিয়ে যান!",
    "startStreak": "আপনার স্ট্রিক শুরু করুন",
    "checkIn": "চেক-ইন",
    "nutritionPlan": "পুষ্টি পরিকল্পনা",
    "mealsPlanned": "খাবারের পরিকল্পনা করা হয়েছে",
    "viewPlan": "পরিকল্পনা দেখুন",
    "planYourWeek": "আপনার সপ্তাহের পরিকল্পনা করুন",
    "moodStress": "মন মেজাজ ও চাপ",
    "howFeeling": "কেমন বোধ করছেন?",
    "logWellness": "সুস্থতা রেকর্ড করুন",
    "medications": "ওষুধ",
    "noMeds": "কোন ওষুধ ট্র্যাক করা হচ্ছে না",
    "addMedications": "আপনার ওষুধ যোগ করুন",
    "daysTracked": "ট্র্যাক করা দিন",
    "noHabits": "এখনও কোনো অভ্যাস নেই",
    "startTrackingHabits": "অভ্যাস ট্র্যাকিং শুরু করুন",
    "insights": "পর্যবেক্ষণ",
    "noInsights": "এখনও কোনো তথ্য নেই",
    "completeFirstPlan": "আপনার প্রথম পরিকল্পনা সম্পন্ন করুন",
    "noCheckIns": "এখনও কোনো চেক-ইন নেই",
    "startFirstCheckIn": "প্রথম চেক-ইন শুরু করুন"
  },
  "support": {
    "title": "সহায়তা",
    "subtitle": "উত্তর খুঁজুন, আমাদের সাথে যোগাযোগ করুন বা কোনো সমস্যা জানান",
    "backToSettings": "সেটিংস-এ ফিরে যান",
    "privacyBanner": "সহায়তার অনুরোধগুলো ব্যক্তিগত এবং নিরাপদে পরিচালনা করা হয়। আপনার স্বাস্থ্যের তথ্য গোপন থাকে।",
    "section1": "বিভাগ ১",
    "section2": "বিভাগ ২",
    "section3": "বিভাগ ৩",
    "section4": "বিভাগ ৪",
    "navHelpCenter": "সহায়তা কেন্দ্র",
    "navContact": "সহায়তার জন্য যোগাযোগ",
    "navHealth": "স্বাস্থ্য পরিষেবা",
    "navTechnical": "কারিগরি সহায়তা",
    "helpCenterTitle": "সহায়তা কেন্দ্র",
    "helpCenterSubtitle": "সাধারণ প্রশ্নগুলো খুঁজুন এবং দ্রুত উত্তর পান।",
    "contactTitle": "সহায়তার জন্য যোগাযোগ",
    "contactSubtitle": "আপনার পছন্দের মাধ্যমে আমাদের টিমের সাথে যোগাযোগ করুন।",
    "healthServicesTitle": "স্বাস্থ্য পরিষেবা",
    "healthServicesSubtitle": "ওষুধ ট্র্যাকিং এবং ক্লিনিকাল বিশেষজ্ঞদের সাথে যুক্ত হন।",
    "technicalTitle": "কারিগরি সহায়তা",
    "technicalSubtitle": "বিস্তারিত তথ্যসহ বাগ বা কারিগরি সমস্যা রিপোর্ট করুন।",
    "searchPlaceholder": "সাধারণ প্রশ্নগুলো খুঁজুন…",
    "liveChat": "লাইভ চ্যাট",
    "emailUs": "আমাদের ইমেল করুন",
    "callBack": "কলব্যাকের সময় নির্ধারণ করুন",
    "sendMessage": "বার্তা পাঠান",
    "medicationTracking": "ওষুধ ট্র্যাকিং",
    "specialistAccess": "বিশেষজ্ঞ সুবিধা",
    "videoConsultation": "ভিডিও পরামর্শ",
    "reportBug": "সমস্যা (Bug) জানান",
    "yourName": "আপনার নাম",
    "yourEmail": "আপনার ইমেল",
    "subject": "বিষয়",
    "message": "বার্তা",
    "phone": "ফোন",
    "description": "বর্ণনা",
    "submit": "জমা দিন",
    "successTitle": "বার্তা পাঠানো হয়েছে",
    "successDescription": "আমরা ২৪-৪৮ ঘণ্টার মধ্যে উত্তর দেব।",
    "healthDisclaimer": "জরুরি চিকিৎসার জন্য স্থানীয় জরুরি পরিষেবার সাথে যোগাযোগ করুন। HealthLoop পেশাদার চিকিৎসা সেবার বিকল্প নয়।"
  },
  "nutrition": {
    "smartNutrition": "স্মার্ট পুষ্টি",
    "basedOnGoal": "আপনার লক্ষ্যের ওপর ভিত্তি করে:",
    "personalizedData": "আপনার সাম্প্রতিক স্বাস্থ্য তথ্যের ভিত্তিতে ব্যক্তিগতকৃত",
    "evidenceBased": "আপনার প্রতিরোধমূলক স্বাস্থ্য পরিকল্পনার অংশ হিসেবে প্রমাণ-ভিত্তিক পুষ্টি",
    "todaysMealSuggestions": "আজকের খাবারের পরামর্শ",
    "customize": "পছন্দমতো সাজান",
    "breakfast": "প্রাতঃরাশ",
    "lunch": "মধ্যাহ্নভোজ",
    "dinner": "রাতের খাবার",
    "loadingBreakfast": "প্রাতঃরাশ লোড হচ্ছে...",
    "loadingLunch": "মধ্যাহ্নভোজ লোড হচ্ছে...",
    "loadingDinner": "রাতের খাবার লোড হচ্ছে...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "খাবার পরিবর্তন করুন",
    "healthyOptionsNearYou": "আপনার কাছাকাছি স্বাস্থ্যকর অপশন",
    "enableLocation": "লোকেশন চালু করুন",
    "view": "দেখুন",
    "discoverOptions": "আপনার কাছাকাছি স্বাস্থ্যকর রেস্তোরাঁ, মুদি দোকান এবং মিল প্রেপ ভেন্ডর খুঁজুন",
    "cuisinesSelected": "খাবার নির্বাচিত",
    "cuisineSelected": "খাবার নির্বাচিত",
    "dietaryPrefs": "ডায়েটরি পছন্দ",
    "dietaryPref": "ডায়েটরি পছন্দ",
    "customizeMeals": "খাবার কাস্টমাইজ করুন",
    "subtitleAdaptive": "আপনার স্বাস্থ্য লক্ষ্যের জন্য মানানসই এবং ব্যক্তিগতকৃত খাবারের পরিকল্পনা",
    "hideFavorites": "পছন্দসই তালিকা লুকান",
    "viewFavorites": "পছন্দসই তালিকা দেখুন",
    "customizeMealsLegacy": "আপনার সাংস্কৃতিক পছন্দ এবং ডায়েটরি প্রয়োজন অনুযায়ী খাবার সাজান",
    "viewFullPlan": "সম্পূর্ণ পরিকল্পনা দেখুন",
    "exploreRecipes": "রেসিপি দেখুন"
  },
  "location": {
    "permissionTitle": "আপনার কাছে স্বাস্থ্যকর অপশন খুঁজুন",
    "permissionDesc": "আপনার স্বাস্থ্য লক্ষ্যের সাথে সামঞ্জস্যপূর্ণ রেস্তোরাঁ, মুদি দোকান এবং খাবারের দোকান খুঁজে পেতে ব্যবহৃত হয়।",
    "howToEnable": "কীভাবে চালু করবেন:",
    "step1": "আপনার ব্রাউজারের অ্যাড্রেস বারে তালা আইকন 🔒 ক্লিক করুন",
    "step2": "লোকেশন (Location) পারমিশন খুঁজুন",
    "step3": "সেটি 'অ্যালাউ' (Allow) করুন",
    "step4": "এই পেজটি রিফ্রেশ করুন",
    "refreshPage": "পেজ রিফ্রেশ করুন",
    "allowLocation": "লোকেশন ব্যবহারের অনুমতি দিন",
    "notNow": "এখন নয়",
    "denied": "লোকেশন অ্যাক্সেস ব্লক করা হয়েছে। আপনার কাছাকাছি স্বাস্থ্যকর বিকল্পগুলো দেখতে লোকেশন পারমিশন চালু করতে হবে।",
    "unavailable": "লোকেশন সংক্রান্ত তথ্য বর্তমানে পাওয়া যাচ্ছে না। অনুগ্রহ করে আপনার ডিভাইসের সেটিংস চেক করুন।",
    "error": "আপনার লোকেশন পাওয়া যাচ্ছে না। অনুগ্রহ করে আবার চেষ্টা করুন বা ব্রাউজার সেটিংস চেক করুন।",
    "unsupported": "আপনার ব্রাউজার লোকেশন পরিষেবা সমর্থন করে না। ক্রোম, ফায়ারফক্স বা সাফারির মতো আধুনিক ব্রাউজার ব্যবহার করার চেষ্টা করুন।",
    "accessRequired": "লোকেশন অ্যাক্সেস প্রয়োজন"
  },
  "womensHealth": {
    "title": "নারীর স্বাস্থ্য",
    "description": "আপনার পিরিয়ড সাইকেল ট্র্যাক করুন, উপসর্গগুলো লিখুন এবং সাইকেলের ধাপ অনুযায়ী ব্যক্তিগত স্বাস্থ্য টিপস পান",
    "cycleTracking": "সাইকেল ট্র্যাকিং",
    "symptomLogging": "উপসর্গ রেকর্ড করা",
    "phaseInsights": "সাইকেলের ধাপ বিশ্লেষণ",
    "logPeriod": "পিরিয়ড রেকর্ড করুন",
    "logSymptoms": "উপসর্গ যোগ করুন",
    "insights": "পর্যবেক্ষণ",
    "tips": "স্বাস্থ্য টিপস",
    "overview": "সংক্ষিপ্ত বিবরণ",
    "history": "ইতিহাস",
    "startTracking": "আপনার সাইকেল ট্র্যাক করা শুরু করুন"
  },
  "profile": {
    "title": "প্রোফাইল",
    "personalInfo": "ব্যক্তিগত তথ্য",
    "healthProfile": "স্বাস্থ্য প্রোফাইল",
    "preferences": "পছন্দসমূহ",
    "language": "ভাষা",
    "selectLanguage": "ভাষা নির্বাচন করুন",
    "notifications": "নোটিফিকেশন",
    "privacy": "গোপনীয়তা",
    "security": "নিরাপত্তা",
    "quickAccess": "দ্রুত অ্যাক্সেস",
    "editProfile": "প্রোফাইল সম্পাদনা",
    "viewStats": "পরিসংখ্যান দেখুন",
    "backToDashboard": "হোম-এ ফিরে যান",
    "womensHealthTitle": "নারীর স্বাস্থ্য",
    "womensHealthDesc": "সাইকেল ট্র্যাকিং, উপসর্গ এবং সুস্থতার টিপস",
    "healthRemindersTitle": "স্বাস্থ্য রিমাইন্ডার",
    "healthRemindersDesc": "আপনার নোটিফিকেশন ম্যানেজ করুন",
    "manageRemindersDesc": "আপনার রিমাইন্ডার পছন্দ এবং নোটিফিকেশন ম্যানেজ করুন",
    "healthPatternAlerts": "আপনার স্বাস্থ্যের প্যাটার্ন অ্যালার্ট",
    "supportHelp": "সহায়তা ও সাহায্য",
    "supportHelpDesc": "সহায়তা নিন, সমস্যা রিপোর্ট করুন বা সাধারণ প্রশ্নগুলো দেখুন",
    "admin": "অ্যাডমিন",
    "adminDesc": "ব্যবহারের পরিসংখ্যান এবং ব্যবহারকারীর আচরণের তথ্য দেখুন",
    "giveFeedback": "মতামত দিন",
    "giveFeedbackDesc": "HealthLoop-এর সাথে আপনার অভিজ্ঞতা শেয়ার করুন",
    "reportProblem": "সমস্যা রিপোর্ট করুন",
    "reportProblemDesc": "বাগ ফিক্স করতে এবং অ্যাপটি উন্নত করতে আমাদের সাহায্য করুন",
    "manageHealthInfo": "ব্যক্তিগতকৃত তথ্যের জন্য আপনার প্রতিরোধমূলক স্বাস্থ্য তথ্য পরিচালনা করুন",
    "basicInformation": "প্রাথমিক তথ্য",
    "fullName": "পুরো নাম",
    "email": "ইমেল",
    "dateOfBirth": "জন্ম তারিখ",
    "gender": "লিঙ্গ",
    "height": "উচ্চতা (সেমি)",
    "weight": "ওজন (কেজি)",
    "medicalConditions": "শারীরিক অবস্থা",
    "allergies": "অ্যালার্জি",
    "personalHealth": "ব্যক্তিগত স্বাস্থ্য",
    "addCondition": "শারীরিক অবস্থা যোগ করুন",
    "addAllergy": "অ্যালার্জি যোগ করুন",
    "saveChanges": "পরিবর্তন সংরক্ষণ করুন",
    "saving": "সংরক্ষণ হচ্ছে...",
    "privacyMessage": "আপনার স্বাস্থ্য সংক্রান্ত তথ্য গোপনীয়তা ও সুরক্ষার মানদণ্ড অনুযায়ী সুরক্ষিত"
  },
  "settings": {
    "title": "সেটিংস",
    "general": "সাধারণ",
    "account": "অ্যাকাউন্ট",
    "appearance": "চেহারা",
    "languageSettings": "ভাষা সেটিংস",
    "changeLanguage": "ভাষা পরিবর্তন করুন",
    "languageNote": "আপনি নতুন ভাষা নির্বাচন করার সাথে সাথেই ইন্টারফেসটি আপডেট হয়ে যায়। আফ্রিকান এবং নতুন যুক্ত হওয়া ভাষাগুলোকে 'Starter' হিসেবে চিহ্নিত করা হয়েছে — এগুলো ব্যাপক প্রসারের জন্য মেশিন দ্বারা অনুদিত এবং বর্তমানে নেটিভ স্পিকারদের দ্বারা পর্যালোচনার অপেক্ষায় রয়েছে।",
    "languageUpdated": "ভাষা সফলভাবে আপডেট করা হয়েছে",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "মেশিন দ্বারা অনুদিত — নেটিভ স্পিকারের পর্যালোচনার অপেক্ষায়।",
    "regions": {
      "global": "বিশ্বব্যাপী",
      "european": "ইউরোপীয় ভাষাসমূহ",
      "middleEastern": "মধ্যপ্রাচ্যের ভাষাসমূহ",
      "asian": "এশীয় ভাষাসমূহ",
      "african": "আফ্রিকান ভাষাসমূহ"
    }
  },
  "search": {
    "triggerLabel": "HealthLoop-এ খুঁজুন",
    "triggerHint": "\"steps\", \"pharmacy\" বা \"pregnancy\" লিখে দেখুন",
    "triggerAriaLabel": "গ্লোবাল সার্চ খুলুন",
    "placeholder": "ফিচার, ট্র্যাকার বা সাহায্য খুঁজুন…",
    "inputAriaLabel": "HealthLoop ফিচার খুঁজুন",
    "modalAriaLabel": "HealthLoop-এ সার্চ করুন",
    "close": "বন্ধ করুন",
    "clear": "মুছে ফেলুন",
    "clearAriaLabel": "সার্চ মুছে ফেলুন",
    "recentSearches": "সাম্প্রতিক সার্চসমূহ",
    "tryFor": "যা লিখে খুঁজতে পারেন",
    "findFeatures": "যেকোনো ফিচার কয়েক সেকেন্ডেই খুঁজে নিন।",
    "searchAcross": "সার্চ করুন",
    "and": "এবং",
    "sections": {
      "home": "হোম",
      "nutrition": "পুষ্টি",
      "family": "পরিবার",
      "services": "পরিষেবা",
      "support": "সহায়তা",
      "profile": "প্রোফাইল"
    },
    "noMatchesFor": "\"{{query}}\"-এর জন্য কিছু পাওয়া যায়নি",
    "trySimpler": "steps, nutrition বা specialist-এর মতো সহজ শব্দ দিয়ে চেষ্টা করুন।",
    "comingSoonBadge": "শীঘ্রই আসছে",
    "escToClose": "বন্ধ করতে",
    "resultSingular": "{{count}}টি ফলাফল",
    "resultPlural": "{{count}}টি ফলাফল",
    "searchAcrossApp": "পুরো অ্যাপ জুড়ে খুঁজুন"
  },
  "familyMember": {
    "confirmRemove": "পরিবারের হেলথ ট্র্যাকিং থেকে কি {{name}}-কে বাদ দিতে চান?",
    "removed": "পরিবার থেকে {{name}}-কে বাদ দেওয়া হয়েছে",
    "removeFailed": "সদস্যকে বাদ দেওয়া যায়নি",
    "viewDetails": "বিস্তারিত দেখুন",
    "edit": "সম্পাদনা করুন",
    "remove": "বাদ দিন",
    "yearsSuffix": "বছর",
    "healthGoalsLabel": "স্বাস্থ্যের লক্ষ্য:",
    "moreSuffix": "আরও",
    "activeInsights": "সক্রিয় ইনসাইটস",
    "viewAllInsights": "সব {{count}}টি ইনসাইটস দেখুন →",
    "viewFullProfile": "পুরো হেলথ প্রোফাইল দেখুন",
    "lifeStage": {
      "infant": "শিশু (০-২)",
      "toddler": "ছোট বাচ্চা (২-৫)",
      "child": "সন্তান (৬-১২)",
      "adolescent": "কিশোর/কিশোরী (১৩-১৭)",
      "adult": "প্রাপ্তবয়স্ক (১৮-৫৯)",
      "senior": "প্রবীণ (৬০+)",
      "unknown": "অজানা"
    }
  },
  "profileDeep": {
    "backToDashboard": "ড্যাশবোর্ডে ফিরে যান",
    "profileCompletion": "প্রোফাইল পূর্ণতা",
    "healthSummary": "স্বাস্থ্য সারাংশ",
    "sectionA": "বিভাগ ক",
    "sectionB": "বিভাগ খ",
    "sectionC": "বিভাগ গ",
    "sectionD": "বিভাগ ঘ",
    "personalDetails": "ব্যক্তিগত তথ্য",
    "healthInformation": "স্বাস্থ্য সংক্রান্ত তথ্য",
    "accountSettings": "অ্যাকাউন্ট সেটিংস",
    "fullName": "পুরো নাম",
    "email": "ইমেইল",
    "dob": "জন্ম তারিখ",
    "gender": "লিঙ্গ",
    "genderPlaceholder": "যেমন: মহিলা, পুরুষ, অন্যান্য",
    "height": "উচ্চতা (সেমি)",
    "heightPlaceholder": "যেমন: 170",
    "weight": "ওজন (কেজি)",
    "weightPlaceholder": "যেমন: 70",
    "allergies": "অ্যালার্জি",
    "allergiesPlaceholder": "যেমন: চিনাবাদাম",
    "medicalConditions": "শারীরিক অবস্থা",
    "conditionsPlaceholder": "যেমন: উচ্চ রক্তচাপ",
    "medications": "ওষুধ",
    "medicationsPlaceholder": "যেমন: লিসিনোপ্রিল 10mg, প্রতিদিন",
    "emergencyContact": "জরুরি যোগাযোগ",
    "emergencyOptional": "(ঐচ্ছিক)",
    "emergencyPlaceholder": "যেমন: মা +১-৫৫৫-০১০০",
    "emergencyNote": "আপনি অনুমতি দিলেই কেবল এটি বিশেষজ্ঞের সাথে শেয়ার করা হবে।",
    "saveChanges": "পরিবর্তন সংরক্ষণ করুন",
    "saving": "সংরক্ষণ করা হচ্ছে…",
    "editProfile": "প্রোফাইল এডিট করুন",
    "cancelEditing": "এডিট বাতিল করুন",
    "healthScore": "হেলথ স্কোর",
    "streak": "ধারাবাহিকতা",
    "streakDays": "{{n}} দিন",
    "memberSince": "সদস্যপদ শুরু",
    "remindersActive": "রিমাইন্ডার চালু আছে",
    "conditionsTracked": "স্বাস্থ্য ট্র্যাকিং",
    "nextAgenda": "আপনার পরবর্তী কাজ",
    "notificationsReminders": "নোটিফিকেশন ও রিমাইন্ডার",
    "notificationsRemindersDesc": "স্বাস্থ্য রিমাইন্ডারের সময় ও মাধ্যম পরিচালনা করুন",
    "emailNudges": "ইমেইল রিমাইন্ডার",
    "emailNudgesDesc": "মৃদু রিমাইন্ডার এবং সাপ্তাহিক সারাংশ",
    "on": "চালু",
    "paused": "সাময়িক বন্ধ",
    "privacySecurity": "গোপনীয়তা ও নিরাপত্তা",
    "privacySecurityDesc": "অ্যাকাউন্ট সুরক্ষিত রাখতে পাসওয়ার্ড আপডেট করুন",
    "preferencesTitle": "পছন্দসমূহ",
    "preferencesDesc": "ভাষা, অঞ্চল এবং ব্যক্তিগতকরণ",
    "supportHelp": "সহায়তা ও সাহায্য",
    "supportHelpDesc": "উত্তর খুঁজুন এবং আমাদের সাথে যোগাযোগ করুন",
    "giveFeedback": "মতামত দিন",
    "giveFeedbackDesc": "আমাদের কী উন্নত করা উচিত তা জানান",
    "reportProblem": "সমস্যার কথা জানান",
    "reportProblemDesc": "কোনো ত্রুটি খুঁজে পেয়েছেন? আমাদের জানান",
    "adminInsights": "অ্যাডমিন ইনসাইটস",
    "adminInsightsDesc": "ব্যবহারের বিশ্লেষণ",
    "adminBadge": "অ্যাডমিন",
    "shareWithClinician": "বিশেষজ্ঞের সাথে শেয়ার করুন",
    "shareWithClinicianDesc": "শুধুমাত্র পড়ার যোগ্য সারাংশ · স্বয়ংক্রিয়ভাবে মেয়াদ শেষ হবে · যেকোনো সময় বাতিলযোগ্য",
    "share": "শেয়ার করুন",
    "profileMayBeOutOfDate": "প্রোফাইলটি পুরনো হতে পারে",
    "profileMayBeOutOfDateDesc": "সঠিক দিকনির্দেশনার জন্য আপনার স্বাস্থ্যের তথ্য আপডেট রাখুন — এমনকি ছোটখাটো পরিবর্তনও (ওজন, ওষুধ) আপনার জন্য সঠিক পরামর্শ দিতে আমাদের সাহায্য করে।",
    "updateNow": "এখনই আপডেট করুন",
    "profileUpdateError": "আপনার পছন্দ আপডেট করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
    "healthLoopUser": "HealthLoop ব্যবহারকারী",
    "updatedLabel": "আপডেট করা হয়েছে",
    "noEntries": "এখনও কোনো তথ্য নেই।",
    "completionComplete": "আপনার প্রোফাইল সম্পন্ন হয়েছে। এখন আমরা আপনাকে সেরা পরামর্শ দিতে পারব। 💚",
    "completionAlmostThere": "প্রায় শেষ। আরও কিছু তথ্য দিলে আরও নির্ভুল পরামর্শ পাওয়া যাবে।",
    "completionInProgress": "উন্নত স্বাস্থ্য পরামর্শ পেতে আপনার প্রোফাইল সম্পূর্ণ করুন।",
    "justNow": "এইমাত্র",
    "minAgo": "{{n}} মিনিট আগে",
    "minsAgo": "{{n}} মিনিট আগে",
    "hourAgo": "{{n}} ঘণ্টা আগে",
    "hoursAgo": "{{n}} ঘণ্টা আগে",
    "dayAgo": "{{n}} দিন আগে",
    "daysAgo": "{{n}} দিন আগে",
    "checkinDueToday": "আজকের চেক-ইন বাকি আছে",
    "checkinDueTonight": "আজ রাতের চেক-ইন বাকি আছে"
  },
  "supportDeep": {
    "backToSettings": "সেটিংসে ফিরে যান",
    "quickNavAria": "সহায়তা বিভাগ",
    "searchPlaceholder": "সাহায্য খুঁজুন…",
    "searchAria": "সাধারণ জিজ্ঞাসাগুলো খুঁজুন",
    "resultsCount": "{{n}}টি ফলাফল",
    "resultsCountPlural": "{{n}}টি ফলাফল",
    "questionsCount": "{{n}}টি প্রশ্ন",
    "liveChatTitle": "লাইভ চ্যাট",
    "liveChatDesc": "সরাসরি কথা বলুন · সোম–শুক্র সকাল ৯টা–সন্ধ্যা ৬টা",
    "startChat": "চ্যাট শুরু করুন",
    "liveChatSoonToast": "লাইভ চ্যাট শীঘ্রই চালু হচ্ছে। ততক্ষণ পর্যন্ত ইমেইল করতে পারেন।",
    "emailUsTitle": "ইমেইল করুন",
    "emailUsDesc": "২৪–৪৮ ঘণ্টার মধ্যে উত্তর দেওয়া হবে",
    "copy": "কপি",
    "emailCopied": "ইমেইল ক্লিপবোর্ডে কপি করা হয়েছে।",
    "contactFormTitle": "যোগাযোগ ফর্ম",
    "contactFormDesc": "আমাদের মেসেজ পাঠান — আমরা ইমেইলে উত্তর দেব।",
    "yourNameLabel": "আপনার নাম *",
    "namePlaceholder": "আপনার নাম লিখুন",
    "yourEmailLabel": "আপনার ইমেইল *",
    "emailPlaceholder": "example@email.com",
    "subjectOptional": "বিষয় (ঐচ্ছিক)",
    "subjectPlaceholder": "আমরা কীভাবে সাহায্য করতে পারি?",
    "messageLabel": "মেসেজ *",
    "messagePlaceholder": "আপনার কী প্রয়োজন তা আমাদের জানান।",
    "sending": "পাঠানো হচ্ছে…",
    "sendMessage": "মেসেজ পাঠান",
    "messageSent": "মেসেজ পাঠানো হয়েছে",
    "messageSentDesc": "আমরা ২৪–৪৮ ঘণ্টার মধ্যে উত্তর দেব।",
    "callbackTitle": "কলব্যাক অনুরোধ",
    "callbackDesc": "আপনার সুবিধাজনক সময়ে আমরা আপনাকে ফোন দেব।",
    "phoneLabel": "ফোন নম্বর *",
    "phonePlaceholder": "+৮৮০",
    "preferredTimeLabel": "পছন্দের সময় (ঐচ্ছিক)",
    "preferredTimePlaceholder": "যেমন: আগামীকাল বিকেল",
    "reasonLabel": "কারণ (ঐচ্ছিক)",
    "reasonPlaceholder": "সংক্ষেপে, আপনি কী নিয়ে আলোচনা করতে চান?",
    "submitting": "জমা দেওয়া হচ্ছে…",
    "requestCallback": "কলব্যাক অনুরোধ করুন",
    "callbackRequested": "কলব্যাকের অনুরোধ জানানো হয়েছে",
    "callbackRequestedDesc": "আমরা ২৪ ঘণ্টার মধ্যে যোগাযোগ করব।",
    "medicationSupport": "ওষুধ সংক্রান্ত সহায়তা",
    "medicationSupportDesc": "প্রেসক্রিপশন, রিফিল এবং রিমাইন্ডার ট্র্যাক করুন।",
    "goToMedications": "ওষুধের তালিকায় যান →",
    "specialistConsultation": "বিশেষজ্ঞ পরামর্শ",
    "specialistConsultationDesc": "ব্যক্তিগত স্বাস্থ্য নির্দেশনার জন্য একজন বিশেষজ্ঞের সাথে যুক্ত হন।",
    "connectExpert": "বিশেষজ্ঞের সাথে কথা বলুন →",
    "videoConsult": "ভিডিও পরামর্শ",
    "videoConsultDesc": "বিশেষজ্ঞের সাথে সরাসরি ভিডিও সেশন বুক করুন।",
    "bookConsultation": "পরামর্শ বুক করুন →",
    "premium": "প্রিমিয়াম",
    "healthDisclaimer": "HealthLoop আপনার প্রতিদিনের সুস্থতায় সহায়তা করে — এটি জরুরি চিকিৎসা সেবার বিকল্প নয়। জরুরি কোনো সমস্যা মনে হলে আপনার স্থানীয় জরুরি সেবার সাথে যোগাযোগ করুন।",
    "categoryLabel": "বিভাগ",
    "catBug": "ত্রুটি / এরর",
    "catPerformance": "ধীর গতি",
    "catFeature": "ফিচার কাজ করছে না",
    "catUi": "ডিসপ্লে সমস্যা",
    "catOther": "অন্যান্য",
    "issueTitle": "সমস্যার শিরোনাম *",
    "issueTitlePlaceholder": "সংক্ষিপ্ত সারাংশ",
    "detailedDescription": "বিস্তারিত বর্ণনা *",
    "detailedDescriptionPlaceholder": "কী ঘটেছিল? সমস্যাটি হওয়ার সময় আপনি কী করছিলেন? ধাপগুলো জানালে আমাদের সুবিধা হয়।",
    "autoAttachNote": "ডিভাইস ও ব্রাউজারের তথ্য স্বয়ংক্রিয়ভাবে যুক্ত করা হয়েছে।",
    "submitReport": "রিপোর্ট জমা দিন",
    "reportSubmitted": "রিপোর্ট জমা দেওয়া হয়েছে",
    "reportSubmittedDesc": "আমাদের টিম এটি নিয়ে কাজ করছে।",
    "fillAllFields": "অনুগ্রহ করে সব প্রয়োজনীয় ঘর পূরণ করুন",
    "problemReportSubmittedToast": "সমস্যার রিপোর্ট জমা দেওয়া হয়েছে। আমরা এটি খতিয়ে দেখে শীঘ্রই আপনার সাথে যোগাযোগ করব।",
    "messageSentToast": "মেসেজ পাঠানো হয়েছে। আমরা ২৪–৪৮ ঘণ্টার মধ্যে উত্তর দেব।",
    "callRequestedToast": "কলের অনুরোধ পাওয়া গেছে। আমরা ২৪ ঘণ্টার মধ্যে যোগাযোগ করব।",
    "submitFailGeneric": "জমা দেওয়া সম্ভব হয়নি। আবার চেষ্টা করুন বা {{email}} এ ইমেইল করুন।",
    "submitFailContact": "পাঠানো সম্ভব হয়নি। অনুগ্রহ করে সরাসরি {{email}} এ ইমেইল করুন।",
    "comingSoon": "শীঘ্রই আসছে",
    "specialistRoadmapTitle": "বিশেষজ্ঞের সাথে কথা বলুন",
    "specialistRoadmapSubtitle": "মানবিক নির্দেশনা শীঘ্রই আসছে। এই ফিচারগুলো এখানে থাকবে যাতে সাহায্য সবসময় হাতের কাছে থাকে।",
    "talkToSpecialistTitle": "বিশেষজ্ঞের সাথে কথা বলুন",
    "talkToSpecialistDesc": "দৈনন্দিন স্বাস্থ্য প্রশ্নের জন্য লাইসেন্সপ্রাপ্ত বিশেষজ্ঞদের সাথে রিয়েল-টাইম চ্যাট।",
    "bookSpecialistTitle": "বিশেষজ্ঞ বুক করুন",
    "bookSpecialistDesc": "আপনার লক্ষ্যের জন্য সঠিক বিশেষজ্ঞের সাথে ১:১ সেশনের সময় নির্ধারণ করুন।",
    "liveHealthGuidanceTitle": "লাইভ স্বাস্থ্য নির্দেশনা",
    "liveHealthGuidanceDesc": "উপসর্গ, ল্যাব রিপোর্ট বা সুস্থতার পরিকল্পনা নিয়ে ভিডিও পরামর্শ।",
    "mentalWellnessTitle": "মানসিক সুস্থতা সহায়তা",
    "mentalWellnessDesc": "জীবনের কঠিন সময়ে মানসিক স্বাস্থ্য বিশেষজ্ঞদের কাছ থেকে গোপনীয় সহায়তা।",
    "wellnessNavigationTitle": "সুস্থতা নেভিগেশন",
    "wellnessNavigationDesc": "আপনাকে সঠিক পরবর্তী ধাপ বেছে নিতে সাহায্য করার জন্য একটি নির্দেশিকা।",
    "pharmacyRoadmapTitle": "ওষুধ ও ফার্মেসি সহায়তা",
    "pharmacyRoadmapSubtitle": "ফার্মেসি সংক্রান্ত সব সাহায্য এখন এই সাপোর্ট বিভাগেই পাবেন।",
    "medicationGuidanceTitle": "ওষুধ সংক্রান্ত নির্দেশিকা",
    "medicationGuidanceDesc": "ওষুধের মাত্রা, সময় এবং পার্শ্বপ্রতিক্রিয়া সম্পর্কে সহজ ভাষায় নির্দেশনা।",
    "findNearbyPharmacyTitle": "কাছের ফার্মেসি খুঁজুন",
    "findNearbyPharmacyDesc": "আপনার প্রয়োজনে রিফিল পেতে এলাকার বিশ্বস্ত ফার্মেসিগুলো দ্রুত খুঁজে বের করুন।",
    "refillReminderTitle": "ওষুধের রিফিল রিমাইন্ডার",
    "refillReminderDesc": "মৃদু রিমাইন্ডার যাতে আপনার প্রয়োজনীয় ওষুধ কখনো ফুরিয়ে না যায়।",
    "otcWellnessTitle": "সাধারণ ওষুধের পরামর্শ",
    "otcWellnessDesc": "নিরাপদ ও তথ্যভিত্তিক সাধারণ (OTC) ওষুধ সম্পর্কে যাচাইকৃত নির্দেশনা।"
  },
  "careServices": {
    "pageTitle": "সেবা সমূহ",
    "pageSubtitle": "আপনার প্রতিদিনের সুস্বাস্থ্যের জন্য বিশেষজ্ঞ ও সুস্থতা সহায়তা।",
    "specialistCareTitle": "বিশেষজ্ঞ সেবা",
    "specialistCareSubtitle": "প্রয়োজনীয় বিশেষজ্ঞদের সাথে কথা বলুন এবং অ্যাপয়েন্টমেন্ট বুক করুন।",
    "medicationPharmacyTitle": "ওষুধ ও ফার্মেসি",
    "medicationPharmacySubtitle": "ওষুধ সংক্রান্ত সহজ নির্দেশনা এবং ফার্মেসি সহায়তা।",
    "wellnessSupportTitle": "সুস্থতা সহায়তা",
    "wellnessSupportSubtitle": "মানসিক স্বাস্থ্য, সাধারণ ওষুধের পরামর্শ এবং সঠিক দিকনির্দেশনা।",
    "futureWellnessTitle": "ভবিষ্যৎ সুস্থতা ফিচার",
    "futureWellnessSubtitle": "HealthLoop-এর আগামীর স্বাস্থ্য পরিকল্পনাগুলোর এক ঝলক।",
    "futureFeatureBadge": "আগামীর ফিচার",
    "futurePersonalizedMealsTitle": "ব্যক্তিগত খাবার পরিকল্পনা",
    "futurePersonalizedMealsDesc": "আপনার লক্ষ্য, অ্যালার্জি এবং সংস্কৃতি অনুযায়ী খাবার তালিকা।",
    "futureHealthyDeliveryTitle": "সুস্থ খাবার ডেলিভারি",
    "futureHealthyDeliveryDesc": "স্বাস্থ্য সচেতন কিচেন ও পার্টনারদের কাছ থেকে যাচাইকৃত খাবার সরবরাহ।",
    "futureFarmFreshTitle": "খামার থেকে তাজা খাবার",
    "futureFarmFreshDesc": "স্থানীয় খামার ও মৌসুমী সতেজ খাবার সরবরাহকারীদের সাথে সরাসরি সংযোগ।",
    "futureFoodPartnershipsTitle": "খাবার পার্টনারশিপ",
    "futureFoodPartnershipsDesc": "স্বাস্থ্যকর কিচেন ও গ্রোসারি ব্র্যান্ডের সাথে আমাদের সংযোগ।",
    "futureNutritionCoachingTitle": "পুষ্টি পরামর্শ",
    "futureNutritionCoachingDesc": "দক্ষ পুষ্টিবিদদের কাছ থেকে সরাসরি নির্দেশনা।",
    "futureFamilyWellnessTitle": "পারিবারিক সুস্থতা পরিকল্পনা",
    "futureFamilyWellnessDesc": "পুরো পরিবারের সুস্বাস্থ্য বজায় রাখতে সম্মিলিত পরিকল্পনা।",
    "futureWellnessPlusTitle": "Wellness+ মেম্বারশিপ",
    "futureWellnessPlusDesc": "ব্যক্তিগত নির্দেশনা এবং অগ্রাধিকার ভিত্তিতে সহায়তার জন্য একটি প্রিমিয়াম স্তর।",
    "futurePharmacyPartnersTitle": "ফার্মেসি পার্টনারশিপ",
    "futurePharmacyPartnersDesc": "ওষুধের পরামর্শ ও রিফিলের জন্য বিশ্বস্ত ফার্মেসি নেটওয়ার্ক।",
    "futureAdvancedSpecialistTitle": "উন্নত বিশেষজ্ঞ সেবা",
    "futureAdvancedSpecialistDesc": "বিশেষজ্ঞদের সাথে সমন্বিত যোগাযোগ ও দ্বিতীয় মতামতের সুবিধা।",
    "futureWellnessMarketplaceTitle": "সুস্থতা মার্কেটপ্লেস",
    "futureWellnessMarketplaceDesc": "যাচাইকৃত সুস্থতা পণ্য ও সেবার একটি বিশেষ সংগ্রহশালা।",
    "futureVendorCollabTitle": "ভেন্ডর কোলাবরেশন",
    "futureVendorCollabDesc": "সুস্থ খাবার ও সেবার পার্টনারদের জন্য মানসম্মত অনবোর্ডিং সিস্টেম।"
  },
  "dashboardDeep": {
    "healthProfile": "হেলথ প্রোফাইল",
    "notifications": "নোটিফিকেশন",
    "familyAccounts": "ফ্যামিলি অ্যাকাউন্ট",
    "settings": "সেটিংস",
    "logout": "লগ আউট",
    "allCaughtUp": "সব আপডেট আছে।",
    "weekInReview": "সাপ্তাহিক সারাংশ",
    "dismissNotification": "নোটিফিকেশন সরিয়ে দিন",
    "dismissWeeklyDigest": "সাপ্তাহিক সারাংশ সরিয়ে দিন",
    "notificationsAria": "নোটিফিকেশন",
    "profileMenuAria": "প্রোফাইল মেনু খুলুন",
    "loadingWellness": "আপনার স্বাস্থ্যের সারাংশ লোড হচ্ছে",
    "nextTip": "পরবর্তী পরামর্শ",
    "todayAtGlance": "আজকের এক ঝলক",
    "healthScoreLabel": "হেলথ স্কোর",
    "currentStreakLabel": "বর্তমান ধারাবাহিকতা",
    "todaysProgress": "আজকের অগ্রগতি",
    "insightForYou": "আপনার জন্য বিশেষ টিপস",
    "checkMyHealthRisk": "আমার স্বাস্থ্য ঝুঁকি যাচাই করুন",
    "quickAccess": "কুইক অ্যাক্সেস",
    "exploreCareServicesTitle": "সেবাগুলো দেখুন",
    "exploreCareServicesSubtitle": "বিশেষজ্ঞ সেবা · ফার্মেসি · সুস্থতা — সব এক জায়গায়।",
    "familyCare": "পরিবারের যত্ন",
    "healthLibrary": "হেলথ লাইব্রেরি",
    "myHealthData": "আমার স্বাস্থ্যের তথ্য",
    "askQuestion": "প্রশ্ন জিজ্ঞাসা করুন",
    "dashLoadError": "ড্যাশবোর্ড লোড করা যায়নি। আবার চেষ্টা করুন।",
    "taskUpdateError": "টাস্ক আপডেট করা যায়নি। আবার চেষ্টা করুন।",
    "perfectDay": "চমৎকার দিন! 🎉 ধারাবাহিকতা বজায় থাকল।",
    "letsStart": "শুরু করা যাক",
    "yourNextStepToday": "আজকের পরবর্তী ধাপ",
    "completeDailyCheck": "আপনার দৈনন্দিন স্বাস্থ্য পরীক্ষা সম্পন্ন করুন",
    "startDailyCheck": "ডেইলি চেক-ইন শুরু করুন",
    "viewAll": "সব দেখুন",
    "graceProtected": "গ্রেস প্রোটেকশন চালু",
    "todaysHealthRecommendations": "আজকের স্বাস্থ্য সুপারিশ",
    "updateViaCheck": "ডেইলি চেকে আপডেট করুন",
    "healthInsight": "স্বাস্থ্য সংক্রান্ত তথ্য",
    "riskCheckSubtext": "কয়েক সেকেন্ডে ব্যক্তিগত স্বাস্থ্য টিপস পান",
    "foodDiet": "খাবার ও ডায়েট",
    "healthScoreNew": "হেলথ স্কোর · নতুন",
    "letsBuildScore": "চলুন একসাথে আপনার হেলথ স্কোর গড়ি",
    "oneHealthyHabitAtATime": "প্রতিদিন একটি করে সুস্থ অভ্যাস গড়ে তুলুন।",
    "nextCheck": "পরবর্তী চেক-ইন:",
    "todayAt8pm": "আজ রাত ৮:০০ টায়",
    "wellnessTipForYou": "আজকের সুস্থতার টিপস · আপনার জন্য",
    "wellnessTipForFactor": "আজকের সুস্থতার টিপস · আপনার {{factor}} এর জন্য",
    "logged": "নথিভুক্ত",
    "gotIt": "বুঝেছি 👍",
    "gladToSeeYou": "আজ আপনাকে দেখে আমরা আনন্দিত 💚",
    "takesLessThan60Sec": "৬০ সেকেন্ডেরও কম সময় লাগবে",
    "scoreReadyWhenYou": "আপনি তৈরি হলেই শুরু করুন",
    "scoreCompleteFirstCheck": "ব্যক্তিগত স্বাস্থ্য পরামর্শ পেতে আপনার প্রথম চেক-ইন সম্পন্ন করুন।",
    "scoreExcellent": "চমৎকার",
    "scoreSupportExcellent": "আজ আপনি খুব ভালো আছেন। এটি বজায় রাখুন।",
    "scoreGood": "ভালো",
    "scoreSupportGood": "আপনি ভালো করছেন। সুস্থ অভ্যাসগুলো চালিয়ে যান।",
    "scoreModerate": "মোটামুটি",
    "scoreSupportModerate": "আপনি ঠিক আছেন, তবে কিছু দিকে নজর দেওয়া প্রয়োজন।",
    "scoreNeedsAttention": "মনোযোগ প্রয়োজন",
    "scoreSupportNeedsAttention": "আজ আপনার স্বাস্থ্যের দিকে নজর দেওয়া দরকার। ছোট ছোট পরিবর্তন উন্নতি করতে সাহায্য করতে পারে।"
  },
  "emailVerify": {
    "bannerWithEmail": "আপনার ইমেইল ({{email}}) যাচাই করুন যাতে আমরা আপনার অ্যাকাউন্ট সুরক্ষিত রাখতে পারি এবং প্রতিদিনের আপডেট দিতে পারি।",
    "bannerNoEmail": "আপনার ইমেইল যাচাই করুন যাতে আমরা আপনার অ্যাকাউন্ট সুরক্ষিত রাখতে পারি এবং প্রতিদিনের আপডেট দিতে পারি।",
    "sending": "পাঠানো হচ্ছে…",
    "resend": "ইমেইল আবার পাঠান",
    "sentToast": "ভেরিফিকেশন ইমেইল পাঠানো হয়েছে। আপনার ইনবক্স চেক করুন।",
    "sendFailToast": "ভেরিফিকেশন ইমেইল পাঠানো যায়নি। পরে আবার চেষ্টা করুন।"
  },
  "forgotPassword": {
    "title": "পাসওয়ার্ড ভুলে গেছেন?",
    "subtitle": "চিন্তা নেই! আপনার ইমেইল দিন এবং আমরা পাসওয়ার্ড রিসেট করার নিয়ম পাঠাব।",
    "emailLabel": "ইমেইল ঠিকানা",
    "emailPlaceholder": "আপনার.ইমেইল@উদাহরণ.কম",
    "sendResetLink": "রিসেট লিঙ্ক পাঠান",
    "sending": "পাঠানো হচ্ছে…",
    "backToLogin": "লগইন এ ফিরে যান",
    "resendLink": "ইমেইল আবার পাঠান",
    "successTitle": "আপনার ইমেইল চেক করুন",
    "successBody": "যদি {{email}} নামে কোনো অ্যাকাউন্ট থাকে, তবে আমরা সেখানে একটি রিসেট লিঙ্ক পাঠিয়েছি।",
    "linkExpires": "লিঙ্কটির মেয়াদ ৩০ মিনিট পর শেষ হয়ে যাবে।",
    "successToast": "নির্দেশনার জন্য আপনার ইমেইল চেক করুন",
    "errEmptyEmail": "অনুগ্রহ করে আপনার ইমেইল ঠিকানা লিখুন",
    "errInvalidEmail": "অনুগ্রহ করে একটি সঠিক ইমেইল ঠিকানা লিখুন",
    "errNetwork": "সার্ভারে সংযোগ দেওয়া সম্ভব হচ্ছে না। কানেকশন চেক করে আবার চেষ্টা করুন।",
    "errGeneric": "রিসেট ইমেইল পাঠানো যায়নি। আবার চেষ্টা করুন বা সাপোর্টে কথা বলুন।"
  },
  "resetPassword": {
    "title": "নতুন পাসওয়ার্ড সেট করুন",
    "subtitle": "আপনার অ্যাকাউন্টের জন্য একটি শক্তিশালী পাসওয়ার্ড তৈরি করুন",
    "newPasswordLabel": "নতুন পাসওয়ার্ড",
    "newPasswordPlaceholder": "নতুন পাসওয়ার্ড দিন",
    "confirmPasswordLabel": "পাসওয়ার্ড নিশ্চিত করুন",
    "confirmPasswordPlaceholder": "নতুন পাসওয়ার্ড আবার দিন",
    "requirementsHint": "কমপক্ষে ৮টি অক্ষর হতে হবে যাতে বড় হাতের অক্ষর, ছোট হাতের অক্ষর এবং সংখ্যা থাকে",
    "resetPassword": "পাসওয়ার্ড রিসেট করুন",
    "resetting": "রিসেট করা হচ্ছে…",
    "successTitle": "পাসওয়ার্ড সফলভাবে রিসেট হয়েছে!",
    "successBody": "আপনি এখন নতুন পাসওয়ার্ড দিয়ে লগইন করতে পারেন।",
    "successToast": "পাসওয়ার্ড সফলভাবে রিসেট হয়েছে!",
    "goToLogin": "লগইন এ যান",
    "invalidLinkTitle": "অকার্যকর রিসেট লিঙ্ক",
    "invalidLinkBody": "এই রিসেট লিঙ্কটি অকার্যকর বা এর মেয়াদ শেষ হয়ে গেছে।",
    "requestNewLink": "নতুন লিঙ্কের জন্য অনুরোধ করুন",
    "showPassword": "পাসওয়ার্ড দেখান",
    "hidePassword": "পাসওয়ার্ড লুকান",
    "errInvalidLink": "অকার্যকর রিসেট লিঙ্ক",
    "errMismatch": "পাসওয়ার্ড দুটি মেলেনি",
    "errTooShort": "পাসওয়ার্ড কমপক্ষে ৮টি অক্ষরের হতে হবে",
    "errExpiredToken": "রিসেট লিঙ্কের মেয়াদ শেষ বা এটি অকার্যকর। নতুন লিঙ্কের অনুরোধ করুন।",
    "errNetwork": "সার্ভারে সংযোগ দেওয়া যাচ্ছে না। ইন্টারনেট চেক করে আবার চেষ্টা করুন।",
    "errGeneric": "পাসওয়ার্ড রিসেট করা যায়নি। আবার চেষ্টা করুন।"
  },
  "tips": {
    "water1": "ঘুম থেকে ওঠার ৩০ মিনিটের মধ্যে পানি পান করলে শরীরের পানিশূন্যতা দূর হয় এবং শক্তি বৃদ্ধি পায়।",
    "water2": "প্রতিবার খাবারের আগে এক গ্লাস পানি পান করা তৃষ্ণা মেটানোর একটি সহজ উপায়।",
    "water3": "পানিতে এক টুকরো লেবু বা কয়েকটা পুদিনা পাতা মিশিয়ে নিলে এটি আরও সতেজ মনে হয়।",
    "meals1": "প্রতিদিন খাবারের তালিকায় বাড়তি এক অংশ সবজি রাখলে পেট ও হার্ট ভালো থাকে।",
    "meals2": "সকালের নাস্তায় সামান্য বাদাম বা বীজ খেলে সারাদিন শরীরে শক্তি বজায় থাকে।",
    "meals3": "জুসের চেয়ে আস্ত ফল খাওয়া ভালো — এর ফাইবার রক্তে শর্করার মাত্রা নিয়ন্ত্রণে রাখে।",
    "steps1": "খাবারের পর ১০ মিনিট হাঁটলে শরীরের শর্করা বা সুগার সহজে হজম হয়।",
    "steps2": "সকালে ৫ মিনিট স্ট্রেচিং করলে শরীরের জড়তা কাটে এবং সারাদিন মন শান্ত থাকে।",
    "steps3": "দিনে অন্তত একবার সিঁড়ি ব্যবহার করলে হার্টের শক্তি ধীরে ধীরে বৃদ্ধি পায়।",
    "sleep1": "ঘুমানোর এক ঘণ্টা আগে আলো কমিয়ে দিলে শরীর গভীর ঘুমের জন্য তৈরি হতে পারে।",
    "sleep2": "ছুটির দিনসহ প্রতিদিন নির্দিষ্ট সময়ে ঘুম থেকে উঠলে ঘুমের চক্র ঠিক থাকে।",
    "sleep3": "সকালে ১০ মিনিট রোদে থাকলে শরীরের ঘুমের ছন্দ বা রিদম স্বাভাবিকভাবে নিয়ন্ত্রিত হয়।",
    "general1": "দুই মিনিট দীর্ঘশ্বাস নিলে মানসিক চাপ কমে এবং কাজে মনোযোগ বাড়ে।",
    "general2": "আজ ভালো কোনো মুহূর্তের কথা ভাবুন — ছোট ছোট ইতিবাচক চিন্তা মানসিক শক্তি বাড়ায়।",
    "general3": "আপনি আজ নিজের যত্নে সময় দিয়েছেন — এই একটি অভ্যাসই আপনার বাকি সব কাজ সহজ করে দেবে।"
  },
  "factors": {
    "hydration": "পানিশূন্যতা দূর করা",
    "nutrition": "পুষ্টি",
    "movement": "শারীরিক কসরত",
    "sleep": "ঘুম"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "খাবারের তালিকা লোড করা যায়নি",
    "prefsSaved": "খাবারের পছন্দগুলো সেভ করা হয়েছে! তালিকা রিফ্রেশ করা হচ্ছে...",
    "prefsSaveFail": "পছন্দগুলো সেভ করা সম্ভব হয়নি",
    "newOptionsFail": "নতুন বিকল্পগুলো লোড করা যায়নি",
    "invalidZip": "অনুগ্রহ করে একটি সঠিক ৫-সংখ্যার জিপ কোড দিন",
    "noVendorsArea": "এই এলাকায় এখনও কোনো ডেলিভারি পার্টনার নেই। আমরা আমাদের পরিধি বাড়াচ্ছি!",
    "vendorsFetchFail": "ডেলিভারি পার্টনারদের তথ্য পাওয়া যায়নি",
    "selectVendorFirst": "অনুগ্রহ করে প্রথমে একজন ডেলিভারি পার্টনার বেছে নিন",
    "removedFromCart": "কার্ট থেকে সরানো হয়েছে",
    "orderPlaced": "অর্ডার সফলভাবে সম্পন্ন হয়েছে! 🎉",
    "enterZipFirst": "অনুগ্রহ করে প্রথমে ডেলিভারি বিভাগে আপনার জিপ কোড দিন",
    "mealNotAvailable": "এই খাবারটি এখনও আপনার এলাকায় ডেলিভারির জন্য উপলব্ধ নয়",
    "mealUnavailable": "কাছাকাছি কোনো ডেলিভারি পার্টনারের কাছে এই খাবারটি বর্তমানে নেই",
    "vendorOptionsFail": "ডেলিভারি পার্টনারের বিকল্পগুলো লোড করা যায়নি",
    "favoriteSaveFail": "পছন্দের তালিকায় সেভ করা সম্ভব হয়নি",
    "removedFromFavorites": "পছন্দের তালিকা থেকে সরানো হয়েছে",
    "favoriteRemoveFail": "পছন্দের তালিকা থেকে সরানো সম্ভব হয়নি",
    "cartEmpty": "আপনার কার্ট খালি",
    "noMealOptions": "খাবারের কোনো বিকল্প উপলব্ধ নেই",
    "loadingOptions": "খাবারের তালিকা লোড করা হচ্ছে...",
    "selectPreferences": "আপনার খাবারের পছন্দগুলো বেছে নিন",
    "mealBuilder": "মিল বিল্ডার",
    "myFavorites": "আমার পছন্দ",
    "myFavoriteMeals": "আমার প্রিয় খাবার",
    "noFavoritesYet": "এখনও কোনো খাবার প্রিয় তালিকায় নেই!",
    "price": "মূল্য",
    "delivery": "ডেলিভারি",
    "deliveryFee": "ডেলিভারি ফি",
    "distance": "দূরত্ব",
    "subtotal": "সাবটোটাল",
    "total": "মোট",
    "orderNumber": "অর্ডার নম্বর",
    "vendor": "ডেলিভারি পার্টনার",
    "totalAmount": "মোট পরিমাণ",
    "estimatedDelivery": "সম্ভাব্য ডেলিভারি সময়",
    "whyThisMeal": "এই খাবারটি কেন বেছে নেবেন",
    "selectThisMeal": "এই খাবারটি বেছে নিন",
    "swapMeal": "খাবার পরিবর্তন করুন",
    "orderThisMeal": "এই খাবারটি অর্ডার করুন",
    "notAvailableNearYou": "আপনার আশেপাশে উপলব্ধ নেই",
    "tryAdjustingPrefs": "খাবারের পরামর্শ দেখতে আপনার পছন্দগুলো কিছুটা বদলে দেখুন",
    "myMealPlanSummary": "আমার মিল প্ল্যান সারাংশ",
    "saveCompletePlan": "সম্পূর্ণ প্ল্যান সেভ করুন",
    "yourFoodPreferences": "আপনার খাবারের পছন্দসমূহ",
    "editPreferences": "পছন্দ পরিবর্তন করুন",
    "healthyMealDelivery": "সুস্থ্যকর খাবার ডেলিভারি",
    "enableDelivery": "ডেলিভারি চালু করুন",
    "enterZipCode": "উপলব্ধ খাবার দেখতে আপনার পোস্টকোড / জিপ কোড দিন",
    "enterPostcode": "আপনার পোস্টকোড / জিপ কোড লিখুন",
    "postcodePlaceholder": "যেমন: MK10 9XX অথবা 10001",
    "postcodePartialHint": "সঠিক স্থানীয় ফলাফলের জন্য আপনার পুরো পোস্টকোড দিন।",
    "noLocalPartnersFallback": "কাছাকাছি কোনো পার্টনার পাওয়া যায়নি। পরিবর্তে এলাকাভিত্তিক পুষ্টিকর উপাদানের পরামর্শ দেখানো হচ্ছে।",
    "noLivePartnersFallback": "আপনার এলাকায় HealthLoop-এর কোনো খাবার পার্টনার বর্তমানে সক্রিয় নেই।",
    "culturalNutritionTitle": "স্থানীয় পুষ্টিকর খাবারের সন্ধান",
    "culturalNutritionSubtitle": "ব্যক্তিগত স্বাস্থ্যকর জীবনযাত্রার নির্দেশিকা — আপনার এলাকার সাথে সামঞ্জস্যপূর্ণ ও তথ্যবহুল।",
    "viewIngredientGuidance": "নির্দেশিকা দেখুন",
    "popularWellnessTitle": "আপনার এলাকার জনপ্রিয় স্বাস্থ্যকর খাবার",
    "popularWellnessIntro": "আপনার এলাকার উপযোগী পুষ্টিকর উপাদান এবং স্বাস্থ্যকর পরিবেশ যা সাধারণত মানুষ খুঁজে থাকেন।",
    "subsectionPopularFoodsTitle": "প্রতিদিনের সুস্থতার খাবার",
    "subsectionCulturalIngredientsTitle": "ঐতিহ্যবাহী পুষ্টিকর উপাদানের পরামর্শ",
    "subsectionHealthySwapsTitle": "স্বাস্থ্যকর বিকল্পের ধারণা",
    "subsectionLocalEnvironmentTitle": "স্থানীয় সুস্থতার পরিবেশ",
    "subsectionLocalEnvironmentIntro": "আপনার এলাকার এমন জায়গা যেখানে সাধারণত স্বাস্থ্যকর বিকল্পগুলো পাওয়া যায়।",
    "findLocalTitle": "স্থানীয় স্বাস্থ্যকর বিকল্প",
    "findLocalSubtitle": "আপনার এলাকায় কাছাকাছি স্বাস্থ্যকর দোকান এবং পুষ্টিকর উপাদানগুলো খুঁজে নিন।",
    "findOptions": "বিকল্পগুলো খুঁজুন",
    "searching": "খোঁজা হচ্ছে…",
    "nearbyVendorsFound": "কাছাকাছি {{count}}টি স্বাস্থ্যকর বিকল্প পাওয়া গেছে",
    "orderHintEnabled": "ডেলিভারি মূল্য দেখতে নিচের যেকোনো খাবারের কার্ডে \"এই খাবারটি অর্ডার করুন\"-এ ট্যাপ করুন।",
    "orderHintDisabled": "সরাসরি অর্ডার করতে উপরে 'ডেলিভারি চালু করুন' অপশনটি অন করুন।",
    "localIngredientTitle": "স্থানীয় উপকরণের সহজলভ্যতা",
    "localIngredientIntro": "আপনার পরিচিত পুষ্টিকর উপাদান এবং সেগুলো স্থানীয়ভাবে কোথায় পাবেন।",
    "lookFor": "খুঁজুন",
    "noVendorsFallback": "এখানে এখনও কোনো সার্টিফাইড ডেলিভারি পার্টনার নেই — তবে উপরের উপকরণের নির্দেশিকা যেকোনো স্থানীয় বাজার বা গ্রোসারি শপে কাজ করবে।",
    "showingMealsFrom": "খাবারগুলো দেখানো হচ্ছে এখান থেকে:",
    "sectionSnapshot": "প্রতিদিনের পুষ্টির স্ন্যাপশট",
    "sectionSnapshotSubtitle": "আজকের পানির পরিমাণ, ক্যালোরি এবং খাবারের ভারসাম্যের একঝলক।",
    "snapshotHydration": "শরীরে পানির পরিমাণ",
    "snapshotHydrationHint": "আজ ৬–৮ গ্লাস পানি পানের লক্ষ্য রাখুন।",
    "snapshotCalories": "ক্যালোরি",
    "snapshotCaloriesHint": "ট্র্যাকিং সুবিধা শীঘ্রই আসছে।",
    "snapshotBalance": "খাবারের ভারসাম্য",
    "mealsLogged": "টি খাবার বেছে নেওয়া হয়েছে",
    "snapshotTip": "সুস্থতার টিপস",
    "snapshotTipHint": "আপনার পরবর্তী খাবারে একটি অতিরিক্ত সবজি যোগ করুন।",
    "sectionRecommendations": "স্মার্ট পরামর্শ",
    "sectionRecommendationsSubtitle": "আপনার উপযোগী উপকরণের নির্দেশিকা এবং স্বাস্থ্যকর বিকল্পের আইডিয়া।",
    "sectionGoals": "পুষ্টির লক্ষ্য",
    "sectionGoalsSubtitle": "আপনার জন্য গুরুত্বপূর্ণ লক্ষ্যগুলো ট্র্যাক করুন।",
    "goalWeight": "ওজন নিয়ন্ত্রণ",
    "goalWeightDesc": "সুষম ওজনের লক্ষ্য অনুযায়ী তৈরি করা খাবার।",
    "goalEnergy": "শক্তির যোগান",
    "goalEnergyDesc": "দীর্ঘ ও কর্মব্যস্ত দিনের জন্য নিরবচ্ছিন্ন শক্তির উৎস।",
    "goalImmunity": "রোগ প্রতিরোধ ক্ষমতা",
    "goalImmunityDesc": "সুস্থ থাকার জন্য অ্যান্টি-অক্সিডেন্ট সমৃদ্ধ খাবার।",
    "goalFamily": "পরিবারের পুষ্টি",
    "goalFamilyDesc": "শিশু এবং মায়েদের উপযোগী খাবারের বিকল্পসহ।",
    "sectionGuidance": "খাবার নির্দেশিকা",
    "sectionGuidanceSubtitle": "সকাল, দুপুর ও রাতের খাবার এবং স্ন্যাকসের আইডিয়া যা আপনি সহজেই পরিবর্তন করতে পারেন।",
    "futureNutritionTitle": "ভবিষ্যৎ পুষ্টি সহায়তা",
    "futureNutritionBody": "ব্যক্তিগত স্বাস্থ্যকর পুষ্টি, খাবার পার্টনারশিপ এবং পরিবার-কেন্দ্রিক সহায়তা HealthLoop-এর পরবর্তী আপডেটগুলোতে আসছে।",
    "comingSoon": "শীঘ্রই আসছে",
    "coverageLocalStores": "স্থানীয় স্বাস্থ্যকর দোকান",
    "coverageLocalFarms": "স্থানীয় খামার",
    "coverageCertifiedVendors": "সার্টিফাইড ডেলিভারি পার্টনার",
    "coverageFreshProduce": "তাজা শাকসবজি ও ফলমূল",
    "medWellnessFutureTitle": "মেডিসিন ও সুস্থতা সহায়তা",
    "medWellnessFutureDesc": "আপনার পুষ্টি পরিকল্পনার সাথে ওষুধের সচেতনতামূলক নির্দেশিকা। এটি 'সহায়তা ও সাহায্য' বিভাগের অধীনে থাকবে।",
    "pharmacyAssistFutureTitle": "ফার্মেসি সহায়তা",
    "pharmacyAssistFutureDesc": "আপনার খাবারের তালিকার পাশেই কাছাকাছি ফার্মেসি এবং ওষুধ খাওয়ার রিমাইন্ডার খুঁজে নিন। এটি 'সহায়তা ও সাহায্য' বিভাগের অধীনে থাকবে।",
    "savePreferences": "পছন্দগুলো সেভ করুন",
    "quickAccessSavedMeals": "আপনার সেভ করা খাবারগুলো দ্রুত দেখুন",
    "saveMealsFromBuilder": "মিল বিল্ডার ট্যাব থেকে খাবার সেভ করুন",
    "chooseVendor": "এই খাবারটি অর্ডার করতে একজন পার্টনার বেছে নিন",
    "yourCart": "আপনার কার্ট",
    "addMealsToStart": "শুরু করতে নিচের তালিকা থেকে খাবার যোগ করুন",
    "orderPlacedDesc": "আপনার স্বাস্থ্যকর খাবারের অর্ডারটি সফলভাবে সম্পন্ন হয়েছে",
    "continueShopping": "আরও কেনাকাটা করুন",
    "trackOrder": "অর্ডার ট্র্যাক করুন",
    "healthyStoresTitle": "কাছাকাছি স্বাস্থ্যকর দোকান এবং ওয়েলনেস মার্কেট",
    "healthyStoresIntro": "আপনার এলাকায় যে ধরনের স্বাস্থ্যকর দোকানগুলো খুঁজতে পারেন — এগুলো কেবল ধারণার জন্য, ডেলিভারির জন্য নয়।",
    "healthyStoresGuidanceTitle": "স্বাস্থ্যকর কেনাকাটার নির্দেশিকা",
    "healthyStoresDisclaimer": "HealthLoop শুধুমাত্র সাধারণ ওয়েলনেস এবং স্বাস্থ্যকর কেনাকাটার অনুপ্রেরণা শেয়ার করে — এটি কোনো চিকিৎসাগত বা ডায়েট সংক্রান্ত পরামর্শ নয়।",
    "healthyStores": {
      "organic": {
        "type": "অর্গানিক মুদি দোকান",
        "description": "তাজা, কীটনাশকমুক্ত শাকসবজি এবং ন্যূনতম প্রক্রিয়াজাত নিত্যপ্রয়োজনীয় খাবার।",
        "tags": [
          "হোল-ফুডস",
          "তাজা শাকসবজি"
        ]
      },
      "farmers": {
        "type": "ফার্মারস মার্কেট",
        "description": "সরাসরি কৃষকদের কাছ থেকে আসা স্থানীয়ভাবে উৎপাদিত ঋতুভিত্তিক ফলমূল, শাকসবজি এবং ঐতিহ্যবাহী পণ্য।",
        "tags": [
          "স্থানীয়",
          "ঋতুভিত্তিক"
        ]
      },
      "african": {
        "type": "আফ্রিকান ফ্রেশ প্রোডিউস স্টোর",
        "description": "মিষ্টি আলু, কাঁচকলা, শাকপাতা, পাম নাট এবং পশ্চিম ও পূর্ব আফ্রিকার প্রধান খাদ্যসামগ্রী।",
        "tags": [
          "সাংস্কৃতিক",
          "তাজা শাকসবজি"
        ]
      },
      "caribbean": {
        "type": "ক্যারিবিয়ান ন্যাচারাল ফুড মার্কেট",
        "description": "ক্যাললু, কাসাভা, স্কচ বনেট, আকি, ব্রেডফ্রুট এবং দ্বীপপুঞ্জের প্রধান খাদ্যসামগ্রী।",
        "tags": [
          "সাংস্কৃতিক",
          "হোল-ফুডস"
        ]
      },
      "asian": {
        "type": "এশীয় সবজি সুপারমার্কেট",
        "description": "বক চয়, ডাইকন, শালুক বা পদ্মমূল, টফু, তাজা ভেষজ এবং প্যান-এশীয় প্রধান খাবার।",
        "tags": [
          "সাংস্কৃতিক",
          "তাজা শাকসবজি"
        ]
      },
      "halal": {
        "type": "হালাল স্বাস্থ্যকর খাদ্য বাজার",
        "description": "হালাল-প্রত্যয়িত চর্বিহীন প্রোটিন, তাজা শাকসবজি এবং ঐতিহ্যবাহী মশলা।",
        "tags": [
          "হালাল",
          "সাংস্কৃতিক"
        ]
      },
      "mediterranean": {
        "type": "ভূমধ্যসাগরীয় হোল-ফুড মার্কেট",
        "description": "অলিভ অয়েল, শিম বা ডাল জাতীয় শস্য, তাজা ভেষজ, আস্ত শস্যদানা এবং ভূমধ্যসাগরীয় খাবার।",
        "tags": [
          "সাংস্কৃতিক",
          "হোল-ফুডস"
        ]
      },
      "wellness": {
        "type": "ওয়েলনেস-কেন্দ্রিক মুদি দোকান",
        "description": "নির্বাচিত হোল-ফুডস, উদ্ভিদ-ভিত্তিক বিকল্প এবং পরিষ্কার লেবেলযুক্ত প্যান্ট্রি আইটেম।",
        "tags": [
          "হোল-ফুডস",
          "উদ্ভিদ-ভিত্তিক"
        ]
      }
    },
    "healthyShoppingTips": [
      "প্রথমে দোকানের চারপাশ বা প্রান্তভাগ থেকে কেনাকাটা করুন — তাজা শাকসবজি, প্রোটিন এবং দুগ্ধজাত পণ্যের বিকল্পগুলো সাধারণত ওখানেই থাকে।",
      "অত্যধিক প্রক্রিয়াজাত খাবারের চেয়ে আস্ত এবং একক উপাদানযুক্ত খাবারকে প্রাধান্য দিন।",
      "ঋতুভিত্তিক স্থানীয় পণ্য বেছে নিন — এগুলো সাধারণত বেশি তাজা, সাশ্রয়ী এবং পুষ্টিগুণে ভরপুর হয়।",
      "বিক্রেতাদের কাছে পণ্যের উৎস এবং উৎপাদন পদ্ধতি সম্পর্কে জিজ্ঞাসা করুন — অনেকে সানন্দে এটি শেয়ার করেন।"
    ]
  },
  "messages": {
    "success": "সফল হয়েছে!",
    "error": "ত্রুটি",
    "saved": "সফলভাবে সেভ করা হয়েছে",
    "updated": "সফলভাবে আপডেট করা হয়েছে",
    "deleted": "সফলভাবে মুছে ফেলা হয়েছে",
    "confirmDelete": "আপনি কি নিশ্চিতভাবেই এটি মুছে ফেলতে চান?",
    "networkError": "নেটওয়ার্ক সমস্যা। আবার চেষ্টা করুন।",
    "somethingWrong": "কিছু একটা ভুল হয়েছে",
    "failedToLoad": "ড্যাশবোর্ড লোড করা যায়নি",
    "offlineMode": "অফলাইন মোড - সীমিত তথ্য দেখানো হচ্ছে",
    "locationDenied": "লোকেশন অ্যাক্সেস দেওয়া হয়নি। ব্রাউজার সেটিং থেকে এটি চালু করুন।",
    "locationUnavailable": "লোকেশন তথ্য পাওয়া যাচ্ছে না",
    "locationTimeout": "লোকেশন রিকোয়েস্টের সময় পার হয়ে গেছে। আবার চেষ্টা করুন।",
    "locationError": "লোকেশন অ্যাক্সেস করা সম্ভব হচ্ছে না",
    "locationGranted": "লোকেশন অ্যাক্সেস পাওয়া গেছে! কাছের বিকল্পগুলো দেখানো হচ্ছে",
    "locationNotSupported": "আপনার ব্রাউজারে লোকেশন সার্ভিস কাজ করে না",
    "requestingLocation": "লোকেশন অ্যাক্সেস চাওয়া হচ্ছে..."
  },
  "trust": {
    "medicalDisclaimer": "মেডিকেল ডিসক্লেইমার",
    "privacySecure": "আপনার তথ্য ব্যক্তিগত ও নিরাপদ",
    "dataEncrypted": "সব তথ্য এনক্রিপ্টেড এবং গোপনীয়",
    "notMedicalAdvice": "এটি চিকিৎসা পরামর্শ নয়",
    "consultProvider": "সব সময় আপনার চিকিৎসকের পরামর্শ নিন",
    "evidenceBased": "তথ্যনির্ভর নির্দেশিকা",
    "generalEducation": "সাধারণ স্বাস্থ্য শিক্ষা",
    "preventiveGuidance": "প্রতিরোধমূলক নির্দেশিকা",
    "lifestyleSupport": "সচেতনতা এবং জীবনযাত্রার সহায়তার জন্য",
    "lastUpdated": "শেষ আপডেট",
    "expertReviewed": "বিশেষজ্ঞ দ্বারা যাচাইকৃত",
    "aiGenerated": "AI-নির্ভর তথ্য",
    "disclaimerShort": "HealthLoop স্বাস্থ্য শিক্ষা প্রদান করে এবং এটি পেশাদার চিকিৎসা পরামর্শের বিকল্প নয়।",
    "disclaimerFull": "HealthLoop প্রতিরোধমূলক সুস্থতা এবং প্রাথমিক সচেতনতায় সহায়তা করে। আমরা স্বাস্থ্য শিক্ষা, অভ্যাস ট্র্যাকিং এবং সুস্থতার তথ্য প্রদান করি। এটি লাইসেন্সপ্রাপ্ত চিকিৎসা সেবার বিকল্প নয়। চিকিৎসা পরামর্শ, রোগ নির্ণয় বা নিরাময়ের জন্য সর্বদা যোগ্য চিকিৎসকের পরামর্শ নিন।",
    "trustBanner": {
      "title": "HealthLoop আপনার সুস্থতার যাত্রায় পাশে আছে",
      "description": "আমরা নির্ভরযোগ্য উৎসের ভিত্তিতে সাধারণ স্বাস্থ্য শিক্ষা এবং প্রতিরোধমূলক নির্দেশিকা প্রদান করি। এটি পেশাদার চিকিৎসা পরামর্শের বিকল্প নয়। যেকোনো চিকিৎসার সিদ্ধান্তের জন্য সর্বদা চিকিৎসকের পরামর্শ নিন।"
    }
  },
  "health": {
    "preventiveHealth": "প্রতিরোধমূলক স্বাস্থ্য ট্র্যাকার",
    "educationHub": "শিক্ষা কেন্দ্র",
    "engagementWidget": "এনগেজমেন্ট উইজেট",
    "wellnessCheckIn": "সুস্থতা চেক-ইন",
    "todaysMetrics": "আজকের পরিমাপ",
    "bloodPressure": "রক্তচাপ",
    "heartRate": "হৃদস্পন্দন",
    "weight": "ওজন",
    "sleep": "ঘুম",
    "waterIntake": "পানি পান",
    "exercise": "ব্যায়াম",
    "logMetric": "তথ্য যোগ করুন",
    "viewHistory": "ইতিহাস দেখুন"
  },
  "aiInsights": {
    "title": "AI স্বাস্থ্য তথ্য",
    "comingSoon": "আপনার জন্য তথ্য সংগ্রহ করা হচ্ছে",
    "comingSoonDesc": "কয়েকদিন নিয়মিত চেক-ইন সম্পন্ন করুন, আমরা এখানে আপনার জন্য ব্যক্তিগত স্বাস্থ্য টিপস নিয়ে আসব।",
    "learnMore": "আরও জানুন",
    "evidenceSources": {
      "WHO": "WHO-এর নির্দেশিকা অনুযায়ী",
      "NHS": "NHS-এর সুপারিশের সাথে সামঞ্জস্যপূর্ণ",
      "CDC": "CDC-এর নির্দেশিকা দ্বারা সমর্থিত",
      "RESEARCH": "পিয়ার-রিভিউড গবেষণার ভিত্তিতে",
      "CLINICAL": "ক্লিনিকাল স্টাডিজ দ্বারা সমর্থিত"
    }
  },
  "dailyInsight": {
    "title": "প্রতিদিনের স্বাস্থ্য তথ্য",
    "gettingStarted": "শুরু করা যাক",
    "focus": "মূল লক্ষ্য",
    "quickInsight": "একঝলকে তথ্য",
    "simpleExplanation": "সহজ ব্যাখ্যা",
    "realLifeImpact": "বাস্তব জীবনে প্রভাব",
    "yourActionStep": "আপনার করণীয় পদক্ষেপ",
    "basedOnYour": "আপনার তথ্যের ভিত্তিতে",
    "personalizedFor": "আপনার সাম্প্রতিক স্বাস্থ্য তথ্যের ভিত্তিতে ব্যক্তিগতকৃত",
    "getNewInsight": "নতুন তথ্য দেখুন",
    "newInsightLoaded": "নতুন তথ্য লোড হয়েছে! 💡",
    "failedToRefresh": "তথ্য রিফ্রেশ করা যায়নি",
    "priority": {
      "high": "এখানে মনোযোগ দিন",
      "medium": "লক্ষ্য রাখা জরুরি"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "এই মুহূর্তে কোনো স্বাস্থ্য অ্যালার্ট নেই",
    "noAlertsDesc": "আপনি স্বাস্থ্যকর অভ্যাস বজায় রাখছেন। চালিয়ে যান!",
    "whatYouCanDo": "আপনি যা করতে পারেন:",
    "viewMealSuggestions": "আপনার জন্য ব্যক্তিগত খাবারের পরামর্শ দেখুন"
  },
  "engagement": {
    "currentStreak": "বর্তমান স্ট্রিক",
    "bestStreak": "সেরা স্ট্রিক",
    "thisWeek": "এই সপ্তাহ",
    "exerciseDays": "ব্যায়ামের দিন",
    "hydrationDays": "পানি পানের দিন",
    "healthMetricsLogged": "স্বাস্থ্য তথ্য ইনপুট",
    "weeklyGoalsProgress": "সাপ্তাহিক লক্ষ্যের অগ্রগতি",
    "completed": "সম্পন্ন",
    "days": "দিন",
    "keepGoing": "এগিয়ে চলুন!",
    "personalRecord": "ব্যক্তিগত রেকর্ড!",
    "goalMet": "লক্ষ্য পূরণ হয়েছে!"
  },
  "reminders": {
    "title": "স্বাস্থ্য রিমাইন্ডার",
    "subtitle": "স্বাস্থ্য সচেতনতার নোটিফিকেশনের মাধ্যমে লক্ষ্যে অবিচল থাকুন",
    "breakfast": "সকালের নাস্তার রিমাইন্ডার",
    "lunch": "দুপুরের খাবারের রিমাইন্ডার",
    "dinner": "রাতের খাবারের রিমাইন্ডার",
    "water": "পানি পান",
    "movement": "শরীরচর্চার বিরতি",
    "sleep": "ঘুমের রিমাইন্ডার",
    "wellness": "সুস্থতা চেক-ইন",
    "healthLogging": "স্বাস্থ্য তথ্য ইনপুট",
    "annualCheckup": "বার্ষিক চেকআপ",
    "enable": "চালু করুন",
    "disable": "বন্ধ করুন",
    "customize": "সময় পরিবর্তন করুন",
    "stayConsistent": "স্মার্ট রিমাইন্ডারের সাথে নিয়মিত থাকুন",
    "setupFriendly": "সুস্থ অভ্যাসের জন্য প্রয়োজনীয় রিমাইন্ডার সেট আপ করুন।",
    "customizeWhen": "আপনি কতক্ষণ পরপর বা কখন রিমাইন্ডার পেতে চান তা সেট করতে পারেন।",
    "supportive": "চিন্তা করবেন না - এগুলো আপনাকে বিরক্ত করবে না, বরং সাহায্য করবে! 💚",
    "noPreferences": "রিমাইন্ডার সেটিংস পাওয়া যায়নি",
    "noPreferencesDesc": "আমরা আপনার রিমাইন্ডার সেটিংস লোড করতে পারিনি। সম্ভবত আপনি নতুন এসেছেন অথবা কোনো ত্রুটি হয়েছে।",
    "retryLoading": "আবার চেষ্টা করুন",
    "saveSettings": "সেটিংস সেভ করুন",
    "saving": "সেভ হচ্ছে..."
  },
  "empty": {
    "startJourney": "আপনার সুস্থতার যাত্রা শুরু করুন",
    "startJourneyDesc": "আজই শুরু করুন! আপনার অনুভূতি শেয়ার করুন যাতে আমরা আপনাকে ব্যক্তিগত স্বাস্থ্য টিপস দিতে পারি।",
    "completeFirstCheckIn": "প্রথম চেক-ইন সম্পন্ন করুন",
    "stayOnTrack": "লক্ষ্যে স্থির থাকুন",
    "stayOnTrackDesc": "নিয়মিত অভ্যাস বজায় রাখুন 💊 সময়মতো ওষুধ খাওয়ার রিমাইন্ডার পেতে আপনার ওষুধগুলো যোগ করুন।",
    "addFirstMedication": "প্রথম ওষুধটি যোগ করুন",
    "learnMedicationSafety": "ওষুধের সুরক্ষা সম্পর্কে জানুন",
    "buildMealLibrary": "আপনার খাবারের লাইব্রেরি তৈরি করুন",
    "buildMealLibraryDesc": "প্রিয় তালিকায় কোনো খাবার নেই। সহজ মিল প্ল্যানিংয়ের জন্য আপনার পছন্দের খাবারগুলো সেভ করুন।",
    "exploreMealOptions": "খাবারের তালিকা দেখুন",
    "insightsAwait": "আপনার জন্য বিশেষ তথ্য অপেক্ষা করছে",
    "insightsAwaitDesc": "প্রতিদিন চেক-ইন করুন এবং আপনার স্বাস্থ্যের ধরণ ও ব্যক্তিগত টিপস আনলক করতে নিয়মিত ট্র্যাকিং করুন।",
    "startDailyCheckIn": "প্রতিদিনের চেক-ইন শুরু করুন",
    "learnAboutInsights": "হেলথ ইনসাইট সম্পর্কে জানুন",
    "buildingStory": "আপনার সুস্থতার রেকর্ড তৈরি হচ্ছে",
    "buildingStoryDesc": "এখনও কোনো পুরনো তথ্য নেই। আপনি প্রতিদিন চেক-ইন করলে আপনার স্বাস্থ্যের অগ্রগতির গ্রাফ এখানে দেখা যাবে।",
    "completeCheckIn": "চেক-ইন সম্পন্ন করুন",
    "tipComplete7Days": "পরামর্শ: সঠিক প্যাটার্ন বা পরিবর্তনের ধরণ দেখতে অন্তত ৭ দিন চেক-ইন সম্পন্ন করুন।",
    "startTrackingHabits": "সুস্থ অভ্যাস ট্র্যাক করা শুরু করুন",
    "startTrackingHabitsDesc": "এখনও কোনো অভ্যাস ট্র্যাক করা হয়নি। প্রতিদিনের ছোট পদক্ষেপগুলোই বড় পরিবর্তন আনে। আজই রুটিন শুরু করুন।",
    "trackFirstHabit": "প্রথম অভ্যাসটি ট্র্যাক করুন",
    "getMoving": "শরীরচর্চা শুরু করুন",
    "getMovingDesc": "এখনও কোনো অ্যাক্টিভিটি যোগ করা হয়নি। মাত্র ১০ মিনিটের ব্যায়ামও আপনার মন ও শরীর ভালো রাখতে পারে।",
    "logActivity": "অ্যাক্টিভিটি যোগ করুন",
    "allCaughtUp": "সবই আপ-টু-ডেট!",
    "allCaughtUpDesc": "আপনার কোনো নতুন নোটিফিকেশন নেই। নতুন আপডেট বা রিমাইন্ডারের জন্য পরে আবার চেক করুন।",
    "noResultsFound": "কিছু পাওয়া যায়নি",
    "noResultsFoundDesc": "আমরা \"{query}\"-এর জন্য কোনো ফলাফল খুঁজে পাইনি। সার্চ পরিবর্তন করে আবার চেষ্টা করুন।"
  },
  "footer": {
    "tagline": "আপনার এআই-চালিত প্রতিরোধমূলক স্বাস্থ্য সঙ্গী",
    "builtWith": "আপনার সুস্থতার যাত্রার জন্য সযত্নে তৈরি",
    "allRightsReserved": "সর্বস্বত্ব সংরক্ষিত।",
    "about": "আমাদের সম্পর্কে",
    "privacy": "গোপনীয়তা",
    "terms": "শর্তাবলী",
    "contact": "যোগাযোগ",
    "helpCenter": "সহায়তা কেন্দ্র"
  },
  "modals": {
    "feedback": {
      "title": "আপনার মতামত শেয়ার করুন",
      "subtitle": "HealthLoop-কে আরও উন্নত করতে আমাদের সাহায্য করুন",
      "whatWorking": "কোন বিষয়টি ভালো কাজ করছে?",
      "whatImprove": "আমরা আর কী উন্নত করতে পারি?",
      "placeholder": "আপনার চিন্তাভাবনা আমাদের জানান...",
      "thankYou": "আপনার মতামতের জন্য ধন্যবাদ!",
      "submitted": "আপনার মতামত HealthLoop-কে আরও ভালো করতে সাহায্য করে।"
    },
    "reportProblem": {
      "title": "সমস্যার কথা জানান",
      "subtitle": "অ্যাপের ত্রুটি সংশোধন এবং উন্নতিতে আমাদের সাহায্য করুন",
      "describe": "সমস্যাটি বর্ণনা করুন",
      "placeholder": "কী ঘটেছিল? অনুগ্রহ করে বিস্তারিত লিখুন...",
      "optional": "ঐচ্ছিক: সমস্যাটি পুনরায় হওয়ার ধাপগুলো",
      "stepsPlaceholder": "১. আমি এখানে ক্লিক করেছি...\n২. তারপর আমি...",
      "thankYou": "জানানোর জন্য ধন্যবাদ!",
      "submitted": "আমরা দ্রুত বিষয়টি খতিয়ে দেখব।"
    },
    "mealPreferences": {
      "title": "আপনার খাবারের পছন্দ নির্ধারণ করুন",
      "subtitle": "আপনার খাবারের পছন্দ সম্পর্কে আমাদের জানান",
      "cuisines": "পছন্দের রন্ধনশৈলী",
      "selectCuisines": "প্রযোজ্য সবগুলি নির্বাচন করুন",
      "dietary": "খাদ্যতালিকাগত পছন্দ",
      "selectDietary": "আপনার খাদ্যাভ্যাসের প্রয়োজনগুলি বেছে নিন",
      "allergies": "অ্যালার্জি এবং বিধিনিষেধ",
      "allergiesPlaceholder": "যেমন: বাদাম, সামুদ্রিক মাছ, গ্লুটেন",
      "save": "পছন্দগুলি সংরক্ষণ করুন",
      "saving": "সংরক্ষণ করা হচ্ছে..."
    },
    "upgrade": {
      "title": "প্রিমিয়ামে আপগ্রেড করুন",
      "subtitle": "সব ফিচার আনলক করুন",
      "features": "প্রিমিয়াম ফিচারসমূহ",
      "getStarted": "শুরু করুন",
      "learnMore": "আরও জানুন"
    }
  },
  "login": {
    "title": "আপনার প্রতিরোধমূলক স্বাস্থ্য বিষয়ক ইন্টেলিজেন্স প্ল্যাটফর্ম",
    "subtitle": "সমস্যা বাড়ার আগেই ট্র্যাকিং করুন, শিখুন এবং ব্যবস্থা নিন। প্রতিরোধ, শিক্ষা, সচেতনতা এবং সুস্থতার জন্য তৈরি।",
    "email": "ইমেল",
    "password": "পাসওয়ার্ড",
    "signIn": "সাইন ইন",
    "signingIn": "সাইন ইন করা হচ্ছে...",
    "forgotPassword": "পাসওয়ার্ড ভুলে গেছেন?",
    "noAccount": "অ্যাকাউন্ট নেই?",
    "createAccount": "নতুন তৈরি করুন",
    "biometricLogin": "বায়োমেট্রিক দিয়ে সাইন ইন করুন",
    "biometricHelper": "ফিঙ্গারপ্রিন্ট, ফেস আইডি বা উইন্ডোজ হ্যালো ব্যবহার করুন",
    "authenticating": "যাচাই করা হচ্ছে...",
    "vendorPartner": "আপনি কি একজন ভেন্ডর পার্টনার?",
    "vendorLogin": "ভেন্ডর লগইন",
    "emailRequired": "প্রথমে আপনার ইমেল লিখুন",
    "biometricSuccess": "সফলভাবে বায়োমেট্রিক দিয়ে সাইন ইন করা হয়েছে! 🎉",
    "noPasskeys": "কোনো বায়োমেট্রিক লগইন সেট আপ করা নেই। অনুগ্রহ করে প্রথমে পাসওয়ার্ড দিয়ে লগইন করুন।",
    "biometricCancelled": "বায়োমেট্রিক লগইন বাতিল করা হয়েছে",
    "biometricFailed": "বায়োমেট্রিক লগইন ব্যর্থ হয়েছে। অনুগ্রহ করে পাসওয়ার্ড দিয়ে চেষ্টা করুন।"
  },
  "register": {
    "title": "HealthLoop-এ যোগ দিন",
    "subtitle": "আজই আপনার প্রতিরোধমূলক স্বাস্থ্যের যাত্রা শুরু করুন",
    "fullName": "পুরো নাম",
    "email": "ইমেল",
    "password": "পাসওয়ার্ড",
    "confirmPassword": "পাসওয়ার্ড নিশ্চিত করুন",
    "createAccount": "অ্যাকাউন্ট তৈরি করুন",
    "haveAccount": "ইতিমধ্যেই অ্যাকাউন্ট আছে?",
    "signIn": "সাইন ইন",
    "creating": "অ্যাকাউন্ট তৈরি করা হচ্ছে...",
    "passwordTooShort": "পাসওয়ার্ড অন্তত ৮ অক্ষরের হতে হবে",
    "setupBiometric": "বায়োমেট্রিক লগইন সেট আপ করুন",
    "setupBiometricDesc": "দ্রুত ও নিরাপদ লগইনের জন্য আপনার ফিঙ্গারপ্রিন্ট, ফেস আইডি বা উইন্ডোজ হ্যালো ব্যবহার করুন",
    "setupNow": "এখনই সেট আপ করুন",
    "skipForNow": "আপাতত থাক",
    "settingUp": "সেট আপ করা হচ্ছে...",
    "benefit1": "আর পাসওয়ার্ড মনে রাখার ঝামেলা নেই",
    "benefit2": "বায়োমেট্রিক যাচাইকরণের মাধ্যমে অতিরিক্ত সুরক্ষা",
    "benefit3": "এক ট্যাপ বা এক পলকেই সাইন ইন করুন",
    "biometricPrivacy": "আপনার বায়োমেট্রিক তথ্য কখনো আপনার ডিভাইস থেকে বের হয় না",
    "biometricSuccess": "বায়োমেট্রিক লগইন সফলভাবে সেট আপ হয়েছে! 🎉",
    "biometricFailed": "বায়োমেট্রিক লগইন সেট আপ করতে ব্যর্থ। আপনি পরে সেটিংস থেকে এটি সেট আপ করতে পারেন।",
    "biometricSetupLater": "আপনি পরে আপনার প্রোফাইল সেটিংস থেকে বায়োমেট্রিক লগইন সেট আপ করতে পারেন"
  },
  "womensHealthPage": {
    "title": "নারীদের স্বাস্থ্য ট্র্যাকার",
    "subtitle": "আপনার পিরিয়ড সাইকেল, লক্ষণ এবং সুস্থতা ট্র্যাক করুন",
    "cycleOverview": "সাইকেল ওভারভিউ",
    "currentPhase": "বর্তমান পর্যায়",
    "nextPeriod": "পরবর্তী পিরিয়ডের সম্ভাব্য সময়",
    "logPeriod": "পিরিয়ড রেকর্ড করুন",
    "logSymptoms": "লক্ষণগুলো রেকর্ড করুন",
    "insights": "সাইকেল ইনসাইটস",
    "tips": "পর্যায়-ভিত্তিক টিপস",
    "history": "পিরিয়ডের ইতিহাস",
    "noData": "এখনও কোনো তথ্য নেই",
    "noDataDesc": "ব্যক্তিগত পরামর্শ এবং ভবিষ্যৎবাণী পেতে আপনার সাইকেল ট্র্যাকিং শুরু করুন।",
    "startTracking": "ট্র্যাকিং শুরু করুন"
  },
  "notifications": {
    "title": "নোটিফিকেশন",
    "markAllRead": "সব পঠিত হিসেবে চিহ্নিত করুন",
    "noNotifications": "নতুন কোনো নোটিফিকেশন নেই",
    "viewAll": "সব দেখুন"
  },
  "familyHealth": {
    "title": "পরিবার ও শিশুর স্বাস্থ্য",
    "subtitle": "আপনার পুরো পরিবারের জন্য প্রতিরোধমূলক স্বাস্থ্য সহায়তা",
    "tabImmunizations": "টিকাদান",
    "tabEducation": "শিক্ষা",
    "tabReminders": "রিমাইন্ডার",
    "tabPlanner": "ফ্যামিলি প্ল্যানার",
    "immunizations": {
      "title": "টিকাদান সচেতনতা",
      "subtitle": "প্রস্তাবিত টিকা সম্পর্কে অবগত থাকুন",
      "recommendedSchedule": "প্রস্তাবিত সময়সূচী",
      "byAge": "বয়স অনুযায়ী",
      "infants": "শিশু (০-১২ মাস)",
      "toddlers": "ছোট শিশু (১-৩ বছর)",
      "preschool": "প্রাক-বিদ্যালয় (৪-৬ বছর)",
      "schoolAge": "স্কুলগামী (৭-১২ বছর)",
      "teens": "কিশোর-কিশোরী (১৩-১৮ বছর)",
      "adults": "প্রাপ্তবয়স্ক",
      "learnMore": "আরও জানুন",
      "consultDoctor": "ব্যক্তিগত টিকার পরামর্শের জন্য সর্বদা আপনার চিকিৎসকের সাথে কথা বলুন",
      "upcomingReminders": "আসন্ন টিকার রিমাইন্ডার",
      "noReminders": "আসন্ন কোনো টিকার রিমাইন্ডার নেই",
      "addReminder": "টিকার রিমাইন্ডার যোগ করুন",
      "reminderFor": "কার জন্য রিমাইন্ডার",
      "dueDate": "নির্ধারিত তারিখ",
      "notes": "নোট",
      "markComplete": "সম্পন্ন হিসেবে চিহ্নিত করুন"
    },
    "education": {
      "title": "পারিবারিক স্বাস্থ্য শিক্ষা",
      "subtitle": "তথ্য-ভিত্তিক প্রতিরোধমূলক স্বাস্থ্য বিষয়ক তথ্য",
      "categories": "বিভাগসমূহ",
      "infant": "শিশুর যত্ন",
      "child": "শিশুর বিকাশ",
      "nutrition": "পুষ্টি ও বৃদ্ধি",
      "safety": "নিরাপত্তা ও প্রতিরোধ",
      "mental": "মানসিক সুস্থতা",
      "hygiene": "পরিচ্ছন্নতা ও অভ্যাস",
      "searchPlaceholder": "স্বাস্থ্য বিষয়ক বিষয় খুঁজুন...",
      "popularTopics": "জনপ্রিয় বিষয়",
      "readMore": "আরও পড়ুন",
      "readTime": "মিনিট পাঠ"
    },
    "reminders": {
      "title": "পারিবারিক স্বাস্থ্য রিমাইন্ডার",
      "subtitle": "পুরো পরিবারের প্রতিরোধমূলক যত্নে সজাগ থাকুন",
      "createReminder": "রিমাইন্ডার তৈরি করুন",
      "familyMember": "পরিবারের সদস্য",
      "reminderType": "রিমাইন্ডারের ধরন",
      "frequency": "ফ্রিকোয়েন্সি",
      "activeReminders": "সক্রিয় রিমাইন্ডার",
      "upcomingThisWeek": "এই সপ্তাহের আসন্ন",
      "noActiveReminders": "কোনো সক্রিয় রিমাইন্ডার নেই",
      "types": {
        "checkup": "স্বাস্থ্য পরীক্ষা",
        "dental": "দন্ত চিকিৎসক",
        "vision": "চোখ পরীক্ষা",
        "vaccine": "টিকাদান",
        "medication": "ওষুধ",
        "custom": "কাস্টম"
      }
    },
    "planner": {
      "title": "ফ্যামিলি হেলথ প্ল্যানার",
      "subtitle": "আপনার পরিবারের প্রতিরোধমূলক যত্নের পরিকল্পনা করুন",
      "addMember": "পরিবারের সদস্য যোগ করুন",
      "memberName": "সদস্যের নাম",
      "relationship": "সম্পর্ক",
      "dateOfBirth": "জন্ম তারিখ",
      "viewCalendar": "ক্যালেন্ডার দেখুন",
      "upcomingCare": "আসন্ন প্রতিরোধমূলক যত্ন",
      "nothingScheduled": "এখনও কিছু নির্ধারিত হয়নি",
      "scheduleCheckup": "স্বাস্থ্য পরীক্ষার সময় নির্ধারণ করুন",
      "relationships": {
        "child": "সন্তান",
        "spouse": "জীবনসঙ্গী",
        "parent": "বাবা-মা",
        "sibling": "ভাই-বোন",
        "other": "অন্যান্য"
      }
    },
    "content": {
      "infantCare": {
        "title": "শিশুর প্রতিরোধমূলক যত্ন",
        "intro": "আপনার শিশুর প্রথম বছরের জন্য প্রয়োজনীয় স্বাস্থ্য অভ্যাস",
        "topics": [
          "শিশুর নিয়মিত চেকআপের সময়সূচী",
          "বিকাশের ধাপগুলোর দিকে খেয়াল রাখা",
          "নিরাপদ ঘুমের অভ্যাস",
          "পুষ্টি ও খাওয়ানো",
          "টিকাদানের সময়সূচী"
        ]
      },
      "childDevelopment": {
        "title": "শিশুর বিকাশ ও মাইলফলক",
        "intro": "সুস্থ বৃদ্ধি এবং বিকাশ সম্পর্কে জানুন",
        "topics": [
          "শারীরিক বিকাশের ধাপসমূহ",
          "সামাজিক ও মানসিক বৃদ্ধি",
          "ভাষার বিকাশ",
          "চিন্তাশক্তির বিকাশ",
          "কখন ডাক্তারের সাথে কথা বলবেন"
        ]
      },
      "nutrition": {
        "title": "পুষ্টি ও সুস্থ বৃদ্ধি",
        "intro": "শুরু থেকেই স্বাস্থ্যকর খাদ্যাভ্যাস গড়ে তুলুন",
        "topics": [
          "বয়স অনুযায়ী সঠিক পুষ্টি",
          "স্বাস্থ্যকর স্ন্যাকস আইডিয়া",
          "খাবারে অনীহা কাটানো",
          "খাদ্য নিরাপত্তার প্রাথমিক বিষয়",
          "পর্যাপ্ত পানি পানের নির্দেশিকা"
        ]
      },
      "safety": {
        "title": "নিরাপত্তা ও আঘাত প্রতিরোধ",
        "intro": "আপনার পরিবারের জন্য একটি নিরাপদ পরিবেশ তৈরি করুন",
        "topics": [
          "বাড়ির নিরাপত্তা চেকলিস্ট",
          "কার সিট নিরাপত্তা",
          "পানিতে নিরাপত্তা",
          "বিষক্রিয়া প্রতিরোধ",
          "জরুরি অবস্থার প্রস্তুতি"
        ]
      }
    }
  }
};
